import React, { FC, useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { faCaretLeft, faFileExport } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useParams } from "react-router-dom";
import { RegistrationPersonnelHistoryService } from "../../../../../shared/services/Report/RegistrationPersonnelHistory/registration-personnel-history";
import { AxiosError } from "axios/index";
import { notificationService } from "../../../../../shared/services/notification-service";
import useSpinnerLoader from "../../../../../shared/components/spinner-loader";
import {
  calculateAge,
  calculateRetirement,
} from "../../../../../shared/utils/function-employees";
import Moment from "moment";
import { dateDiff } from "../../../../../shared/utils/functions-date-time";
import { getMediaPath } from "../../../../../shared/utils/function-media";

import * as XLSX from "xlsx";

import {
  Document,
  Page,
  Text,
  View,
  PDFViewer,
  PDFDownloadLink,
  Image,
  Font,
} from "@react-pdf/renderer";

Font.register({
  family: "kanit-regular",
  src: "https://fonts.gstatic.com/s/sarabun/v17/DtVjJx26TKEr37c9WBI.ttf",
});
Font.register({
  family: "kanit-200",
  src: "https://fonts.gstatic.com/s/sarabun/v17/DtVmJx26TKEr37c9YL5rulw.ttf",
});

interface ComponentProps {
  isCheckedAll: boolean;
  isCheckedHistory: boolean;
  isCheckedFamilyDetail: boolean;
  isCheckedRename: boolean;
  isCheckedEducation: boolean;
  isCheckedTraining: boolean;
  isCheckedInsignia: boolean;
  isCheckedPunishment: boolean;
  isCheckedOutstandingAwards: boolean;
  isCheckedResignationRetireDeath: boolean;
  isCheckedCertifier: boolean;
  isCheckedWorkOrtokor: boolean;
  isCheckedWorkHistory: boolean;
}

const PersonnelHeader: FC<ComponentProps> = ({
  isCheckedAll,
  isCheckedHistory,
  isCheckedFamilyDetail,
  isCheckedRename,
  isCheckedEducation,
  isCheckedTraining,
  isCheckedInsignia,
  isCheckedPunishment,
  isCheckedOutstandingAwards,
  isCheckedResignationRetireDeath,
  isCheckedCertifier,
  isCheckedWorkOrtokor,
  isCheckedWorkHistory,
}) => {
  let { id } = useParams();
  const [data, setData] = useState<any>([]);
  const [isDisableExport, setDisableExport] = useState<boolean>();

  const { loaderComponent, startLoading, stopLoading } = useSpinnerLoader();

  const [departmentPositions] = useState<any>([
    { value: "ผู้อำนวยการ", code: "2200", label: "ผอ." },
    { value: "รองผู้อำนวยการ อ.ต.ก.", code: "2200.1", label: "ร.ผอ." },
    { value: "สำนักงานผู้อำนวยการ", code: "2203", label: "สผ." },
    { value: "หัวหน้าสำนักงานผู้อำนวยการ", code: "2203", label: "ห.สผ." },
    { value: "สำนักนโยบายและแผน", code: "2200.4", label: "สน.ผ." },
    { value: "ผู้อำนวยการสำนักนโยบายและแผน", code: "2200.4", label: "ผ.สน.ผ." },
    { value: "กองแผนงานและงบประมาณ", code: "2202", label: "กผ." },
    { value: "หัวหน้ากองแผนงานและงบประมาณ", code: "2202", label: "ห.กผ." },
    { value: "กองเทคโนโลยีและสารสนเทศ", code: "2203", label: "กส." },
    { value: "หัวหน้ากองเทคโนโลยีและสารสนเทศ", code: "2203", label: "ห.กส." },
    {
      value: "กองพัฒนาระบบงานและบริหารความเสี่ยง",
      code: "2204",
      label: "กพร.",
    },
    {
      value: "หัวหน้ากองพัฒนาระบบงานและบริหารความเสี่ยง",
      code: "2204",
      label: "ห.กพร.",
    },
    { value: "สำนักตรวจสอบภายใน", code: "2200.4", label: "สต.ภ." },
    { value: "ผู้อำนวยการสำนักตรวจสอบภายใน", code: "2200.4", label: "ผ.สต.ภ." },
    { value: "กลุ่มตรวจสอบระบบปฏิบัติการ", code: "2204", label: "ก.คบ." },
    {
      value: "หัวหน้ากลุ่มตรวจสอบระบบปฏิบัติการ",
      code: "2204",
      label: "ห.กคบ.",
    },
    {
      value: "กลุ่มตรวจสอบการปฏิบัติงานส่วนกลาง",
      code: "2206",
      label: "ก.คก.",
    },
    {
      value: "หัวหน้ากลุ่มตรวจสอบการปฏิบัติงานส่วนกลาง",
      code: "2206",
      label: "ห.กคก.",
    },
    {
      value: "กลุ่มตรวจสอบการปฏิบัติงานส่วนภูมิภาค",
      code: "2207",
      label: "ก.คภ.",
    },
    {
      value: "หัวหน้ากลุ่มตรวจสอบการปฏิบัติงานส่วนภูมิภาค",
      code: "2207",
      label: "ห.กคภ.",
    },
    { value: "ฝ่ายบริหาร", code: "2200.6", label: "ฝบ." },
    { value: "ผู้อำนวยการฝ่ายบริหาร", code: "2200.6", label: "ผ.ฝบ." },
    { value: "กองทรัพยากรบุคคล", code: "2207", label: "กท." },
    { value: "หัวหน้ากองทรัพยากรบุคคล", code: "2207", label: "ห.กท." },
    { value: "กองกฎหมาย", code: "2209", label: "กม." },
    { value: "หัวหน้ากองกฎหมาย", code: "2209", label: "ห.กม." },
    { value: "กองพัสดุ", code: "2210", label: "กพ." },
    { value: "หัวหน้ากองพัสดุ", code: "2210", label: "ห.กพ." },
    { value: "ฝ่ายการเงินและบัญชี", code: "2200.7", label: "ฝง." },
    { value: "ผู้อำนวยการฝ่ายการเงินและบัญชี", code: "2200.7", label: "ผ.ฝง." },
    { value: "กองการเงิน", code: "2211", label: "กง." },
    { value: "หัวหน้ากองการเงิน", code: "2211", label: "ห.กง." },
    { value: "กองบัญชี", code: "2212", label: "กช." },
    { value: "หัวหน้ากองบัญชี", code: "2212", label: "ห.กช." },
    { value: "กองบัญชีสาขา", code: "2213", label: "กชส." },
    { value: "หัวหน้ากองบัญชีสาขา", code: "2213", label: "ห.กชส." },
    { value: "ฝ่ายธุรกิจเกษตร", code: "2200.9", label: "ฝธ." },
    { value: "ผู้อำนวยการฝ่ายธุรกิจเกษตร", code: "2200.9", label: "ผ.ฝธ." },
    { value: "กองธุรกิจข้าว", code: "2214", label: "กธข." },
    { value: "หัวหน้ากองธุรกิจข้าว", code: "2214", label: "ห.กธข." },
    { value: "กองธุรกิจพืชผล", code: "2214", label: "กธพ." },
    { value: "หัวหน้ากองธุรกิจพืชผล", code: "2214", label: "ห.กธพ." },
    { value: "กองธุรกิจปัจจัยการผลิต", code: "2216", label: "กธป." },
    { value: "หัวหน้ากองธุรกิจปัจจัยการผลิต", code: "2216", label: "ห.กธป." },
    { value: "ฝ่ายกิจการตลาด", code: "2200.9", label: "ฝต." },
    { value: "ผู้อำนวยการฝ่ายกิจการตลาด", code: "2200.9", label: "ผ.ฝต." },
    { value: "กลุ่มบริหารงานตลาด", code: "2217", label: "ก.บต." },
    { value: "หัวหน้ากลุ่มบริหารงานตลาด", code: "2217", label: "ห.กบต." },
    { value: "กลุ่มงานแผนจัดเก็บรายได้", code: "2219", label: "ก.รง." },
    { value: "หัวหน้ากลุ่มงานแผนจัดเก็บรายได้", code: "2219", label: "ห.กรง." },
    { value: "กลุ่มพัฒนาธุรกิจตลาด", code: "2219", label: "ก.พต." },
    { value: "หัวหน้ากลุ่มพัฒนาธุรกิจตลาด", code: "2219", label: "ห.กพต." },
    { value: "ฝ่ายกิจการภูมิภาค", code: "2200.10", label: "ฝภ." },
    { value: "ผู้อำนวยการฝ่ายกิจการภูมิภาค", code: "2200.10", label: "ผ.ฝภ." },
    { value: "กลุ่มบริหารงานกิจการภูมิภาค", code: "2220", label: "ก.ภก." },
    {
      value: "หัวหน้ากลุ่มบริหารงานกิจการภูมิภาค",
      code: "2220",
      label: "ห.กภก.",
    },
    { value: "สำนักงาน อ.ต.ก. เขต 1", code: "2221", label: "อ.ต.ก.ข 1" },
    { value: "ผู้จัดการ อ.ต.ก. เขต 1", code: "2221", label: "ผจ.ข.1" },
    {
      value: "สำนักงาน อ.ต.ก. จ.พระนครศรีอยุธยา",
      code: "2221.1",
      label: "อ.ต.ก.ข 1 (อย.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 1 (อ.ต.ก.จ.พระนครศรีอยุธยา)",
      code: "2221.1",
      label: "ร.ผจ.ข.1 (อย.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.ราชบุรี",
      code: "2221.2",
      label: "อ.ต.ก.ข 1 (รบ.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 1 (อ.ต.ก.จ.ราชบุรี)",
      code: "2221.2",
      label: "ร.ผจ.ข.1 (รบ.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.สุพรรณบุรี",
      code: "2221.3",
      label: "อ.ต.ก.ข 1 (สพ.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 1 (อ.ต.ก.จ.สุพรรณบุรี)",
      code: "2221.3",
      label: "ร.ผจ.ข.1 (สพ.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.ฉะเชิงเทรา",
      code: "2221.4",
      label: "อ.ต.ก.ข 1 (ฉช.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 1 (อ.ต.ก.จ.ฉะเชิงเทรา)",
      code: "2221.4",
      label: "ร.ผจ.ข.1 (ฉช.)",
    },
    { value: "สำนักงาน อ.ต.ก. เขต 2", code: "2222", label: "อ.ต.ก.ข 2" },
    { value: "ผู้จัดการ อ.ต.ก. เขต 2", code: "2222", label: "ผจ.ข.2" },
    {
      value: "สำนักงาน อ.ต.ก. จ.เชียงใหม่",
      code: "2222.1",
      label: "อ.ต.ก.ข 2 (ชม.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 2 (อ.ต.ก.จ.เชียงใหม่)",
      code: "2222.1",
      label: "ร.ผจ.ข.2 (ชม.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.พิษณุโลก",
      code: "2222.2",
      label: "อ.ต.ก.ข 2 (พล.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 2 (อ.ต.ก.จ.พิษณุโลก)",
      code: "2222.2",
      label: "ร.ผจ.ข.2 (พล.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.กำแพงเพชร",
      code: "2222.3",
      label: "อ.ต.ก.ข 2 (กพ.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 2 (อ.ต.ก.จ.กำแพงเพชร)",
      code: "2222.3",
      label: "ร.ผจ.ข.2 (กพ.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.นครสวรรค์",
      code: "2222.4",
      label: "อ.ต.ก.ข 2 (นว.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 2 (อ.ต.ก.จ.นครสวรรค์)",
      code: "2222.4",
      label: "ร.ผจ.ข.2 (นว.)",
    },
    { value: "สำนักงาน อ.ต.ก. เขต 3", code: "2223", label: "อ.ต.ก.ข 3" },
    { value: "ผู้จัดการ อ.ต.ก. เขต 3", code: "2223", label: "ผจ.ข.3" },
    {
      value: "สำนักงาน อ.ต.ก. จ.ขอนแก่น",
      code: "2223.1",
      label: "อ.ต.ก.ข 3 (ขก.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 3 (อ.ต.ก.จ.ขอนแก่น)",
      code: "2223.1",
      label: "ร.ผจ.ข.3 (ขก.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.นครราชสีมา",
      code: "2223.2",
      label: "อ.ต.ก.ข 3 (นม.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 3 (อ.ต.ก.จ.นครราชสีมา)",
      code: "2223.2",
      label: "ร.ผจ.ข.3 (นม.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.อุบลราชธานี",
      code: "2223.3",
      label: "อ.ต.ก.ข 3 (อบ.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 3 (อ.ต.ก.จ.อุบลราชธานี)",
      code: "2223.3",
      label: "ร.ผจ.ข.3 (อบ.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.อุดรธานี",
      code: "2223.4",
      label: "อ.ต.ก.ข 3 (อด.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 3 (อ.ต.ก.จ.อุดรธานี)",
      code: "2223.4",
      label: "ร.ผจ.ข.3 (อด.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.สุรินทร์",
      code: "2223.4",
      label: "อ.ต.ก.ข 3 (สร.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 3 (อ.ต.ก.จ.สุรินทร์)",
      code: "2223.4",
      label: "ร.ผจ.ข.3 (สร.)",
    },
    { value: "สำนักงาน อ.ต.ก. เขต 4", code: "2224", label: "อ.ต.ก.ข 4" },
    { value: "ผู้จัดการ อ.ต.ก. เขต 4", code: "2224", label: "ผจ.ข.4" },
    {
      value: "สำนักงาน อ.ต.ก. จ.ตรัง",
      code: "2224.1",
      label: "อ.ต.ก.ข 4 (ตง.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 4 (อ.ต.ก.จ.ตรัง)",
      code: "2224.1",
      label: "ร.ผจ.ข.4 (ตง.)",
    },
    {
      value: "สำนักงาน อ.ต.ก. จ.สงขลา",
      code: "2224.2",
      label: "อ.ต.ก.ข 4 (สข.)",
    },
    {
      value: "รองผู้จัดการ อ.ต.ก. เขต 4 (อ.ต.ก.จ.สงขลา)",
      code: "2224.2",
      label: "ร.ผจ.ข.4 (สข.)",
    },
    { value: "ฝ่ายพัฒนาธุรกิจ", code: "2200.11", label: "ฝพ." },
    { value: "ผู้อำนวยการฝ่ายพัฒนาธุรกิจ", code: "2200.11", label: "ผ.ฝพ." },
    { value: "กลุ่มบริหารงานพัฒนาธุรกิจ", code: "2224", label: "ก.บธ." },
    {
      value: "หัวหน้ากลุ่มบริหารงานพัฒนาธุรกิจ",
      code: "2224",
      label: "ห.กบธ.",
    },
    { value: "กลุ่มกลยุทธ์พัฒนาธุรกิจ", code: "2226", label: "ก.พธ." },
    { value: "หัวหน้ากลุ่มกลยุทธ์พัฒนาธุรกิจ", code: "2226", label: "ห.กพธ." },
    { value: "กลุ่มการค้าต่างประเทศ", code: "2227", label: "ก.คต." },
    { value: "หัวหน้ากลุ่มการค้าต่างประเทศ", code: "2227", label: "ห.กคต." },
    { value: "กลุ่มเทคโนโลยีและนวัตกรรม", code: "2229", label: "ก.ทน." },
    {
      value: "หัวหน้ากลุ่มเทคโนโลยีและนวัตกรรม",
      code: "2229",
      label: "ห.กทน.",
    },
    { value: "กลุ่มพัฒนาผลิตภัณฑ์", code: "2229", label: "ก.พผ." },
    { value: "หัวหน้ากลุ่มพัฒนาผลิตภัณฑ์", code: "2229", label: "ห.กพผ." },
    { value: "กลุ่มธุรกิจการค้า", code: "2230", label: "ก.ธค." },
    { value: "หัวหน้ากลุ่มธุรกิจการค้า", code: "2230", label: "ห.กธค." },
  ]);

  const fetchData = async () => {
    startLoading();
    try {
      const result =
        await RegistrationPersonnelHistoryService.getReportPersonnelHistoryDetail(
          { id: id },
        );
      setData(result);
    } catch (error) {
      const err = error as AxiosError;
      notificationService.dangerNotification(
        "โหลดข้อมูลไม่สำเร็จ",
        err.message,
      );
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (
      isCheckedAll ||
      isCheckedHistory ||
      isCheckedFamilyDetail ||
      isCheckedRename ||
      isCheckedEducation ||
      isCheckedTraining ||
      isCheckedInsignia ||
      isCheckedPunishment ||
      isCheckedOutstandingAwards ||
      isCheckedResignationRetireDeath ||
      isCheckedCertifier ||
      isCheckedWorkOrtokor ||
      isCheckedWorkHistory
    ) {
      setDisableExport(false);
    } else {
      setDisableExport(true);
    }
  }, [
    isCheckedAll,
    isCheckedHistory,
    isCheckedFamilyDetail,
    isCheckedRename,
    isCheckedEducation,
    isCheckedTraining,
    isCheckedInsignia,
    isCheckedPunishment,
    isCheckedOutstandingAwards,
    isCheckedResignationRetireDeath,
    isCheckedCertifier,
    isCheckedWorkOrtokor,
    isCheckedWorkHistory,
  ]);

  const getRetireIn = () => {
    if (data.birthday) {
      const result = calculateRetirement(data.birthday);
      const retire = [];
      if (result.years < 0 || result.months < 0 || result.days < 0) {
        return "เกษียณอายุแล้ว";
      }
      if (result.years) retire.push(`${result.years} ปี`);
      if (result.months) retire.push(`${result.months} เดือน`);
      if (result.days) retire.push(`${result.days} วัน`);

      return retire.join(" ");
    }
    return "-";
  };

  const getAge = (data: any) => {
    if (data) {
      return calculateAge(data) + " ปี";
    }
    return "-";
  };

  const getDateDiff = (start_date: any, end_date: any) => {
    if (start_date && end_date) {
      const data = dateDiff(start_date, end_date);
      const result = [];
      if (data.years) result.push(`${Math.abs(data.years)} ปี`);
      if (data.months) result.push(`${Math.abs(data.months)} เดือน`);
      if (data.days) result.push(`${Math.abs(data.days)} วัน`);
      return result.length > 0 ? result.join(" ") : "1 วัน";
    }
    return "-";
  };

  const exportToExcel = () => {
    var DataForExcel = [];
    const wb = XLSX.utils.book_new();

    if (isCheckedAll) {
      isCheckedHistory = true;
      isCheckedFamilyDetail = true;
      isCheckedRename = true;
      isCheckedEducation = true;
      isCheckedTraining = true;
      isCheckedInsignia = true;
      isCheckedPunishment = true;
      isCheckedOutstandingAwards = true;
      isCheckedResignationRetireDeath = true;
      isCheckedCertifier = true;
      isCheckedWorkOrtokor = true;
      isCheckedWorkHistory = true;
    }

    // ประวัติส่วนตัว
    if (isCheckedHistory) {
      DataForExcel = [];
      DataForExcel.push([
        "รหัสพนักงาน",
        "เกษียณอายุในอีก",
        "เลขบัตรประจำตัวประชาชน",
        "คำนำหน้า (TH)",
        "ชื่อ (TH)",
        "นามสกุล (TH)",
        "คำนำหน้า (EN)",
        "ชื่อ (EN)",
        "นามสกุล (EN)",
        "วันเดือนปีเกิด",
        "อายุ",
        "เพศ",
        "เชื้อชาติ",
        "สัญชาติ",
        "ศาสนา",
        "เบอร์โทรศัพท์",
        "อีเมล",
        "กรุ๊ปเลือด",
        "เงินเดือน",
      ]);
      DataForExcel.push([
        data.code ? data.code : "-",
        getRetireIn(),
        data.id_card ? data.id_card : "-",
        data.prefix_name_th ? data.prefix_name_th : "-",
        data.firstname_th ? data.firstname_th : "-",
        data.lastname_th ? data.lastname_th : "-",
        data.prefix_name_en ? data.prefix_name_en : "-",
        data.firstname_en ? data.firstname_en : "-",
        data.lastname_en ? data.lastname_en : "-",
        data.birthday
          ? Moment(data.birthday).add(543, "year").format("DD/MM/YYYY")
          : "-",
        getAge(data.birthday),
        data.gender ? (data.gender === "MALE" ? "ชาย" : "หญิง") : "-",
        data.ethnicity ? data.ethnicity : "-",
        data.nationality ? data.nationality : "-",
        data.religion ? data.religion : "-",
        data.phone ? data.phone : "-",
        data.user?.email ? data.user?.email : "-",
        data.blood_type ? data.blood_type : "-",
        data.salary ? addCommas(data.salary) : "-",
      ]);

      // กรณีเร่งด่วนติดต่อ
      DataForExcel.push([]);
      DataForExcel.push(["กรณีเร่งด่วนติดต่อ"]);
      DataForExcel.push([
        "ชื่อ - นามสกุล",
        "เบอร์โทรศัพท์",
        "ความสัมพันธ์",
        "สถานที่",
        "รหัสไปรษณีย์",
        "จังหวัด",
        "อำเภอ",
        "ตำบล",
      ]);
      DataForExcel.push([
        data.emergency_contact_full_name
          ? data.emergency_contact_full_name
          : "-",
        data.emergency_contact_tel ? data.emergency_contact_tel : "-",
        data.emergency_contact_relationship
          ? data.emergency_contact_relationship
          : "-",
        data.emergency_contact_address ? data.emergency_contact_address : "-",
        data.emergency_contact_postcode ? data.emergency_contact_postcode : "-",
        data.emergency_contact_province?.name_th
          ? data.emergency_contact_province?.name_th
          : "-",
        data.emergency_contact_amphure?.name_th
          ? data.emergency_contact_amphure?.name_th
          : "-",
        data.emergency_contact_tambon?.name_th
          ? data.emergency_contact_tambon?.name_th
          : "-",
      ]);

      // ที่อยู่ตามบัตรประชาชน
      DataForExcel.push([]);
      DataForExcel.push(["ที่อยู่ตามบัตรประชาชน"]);
      DataForExcel.push([
        "สถานที่",
        "รหัสไปรษณีย์",
        "จังหวัด",
        "อำเภอ",
        "ตำบล",
      ]);
      DataForExcel.push([
        data.address_official ? data.address_official : "-",
        data.postcode_official ? data.postcode_official : "-",
        data.official_province?.name_th ? data.official_province?.name_th : "-",
        data.official_amphure?.name_th ? data.official_amphure?.name_th : "-",
        data.official_tambon?.name_th ? data.official_tambon?.name_th : "-",
      ]);

      // ที่อยู่ปัจจุบัน
      DataForExcel.push([]);
      DataForExcel.push(["ที่อยู่ปัจจุบัน"]);
      DataForExcel.push([
        "สถานที่",
        "รหัสไปรษณีย์",
        "จังหวัด",
        "อำเภอ",
        "ตำบล",
      ]);
      DataForExcel.push([
        data.address_contactable ? data.address_contactable : "-",
        data.postcode_contactable ? data.postcode_contactable : "-",
        data.contactable_province?.name_th
          ? data.contactable_province?.name_th
          : "-",
        data.contactable_amphure?.name_th
          ? data.contactable_amphure?.name_th
          : "-",
        data.contactable_tambon?.name_th
          ? data.contactable_tambon?.name_th
          : "-",
      ]);

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ประวัติส่วนตัว");
    }

    // รายละเอียดครอบครัว
    if (isCheckedFamilyDetail) {
      DataForExcel = [];

      // บิดา
      DataForExcel.push(["บิดา"]);
      DataForExcel.push([
        "คำนำหน้า (TH)",
        "ชื่อ (TH)",
        "นามสกุล (TH)",
        "สถานภาพ",
      ]);
      DataForExcel.push([
        data.contact_father_prefix_name ? data.contact_father_prefix_name : "-",
        data.contact_father_firstname ? data.contact_father_firstname : "-",
        data.contact_father_lastname ? data.contact_father_lastname : "-",
        data.contact_father_status ? data.contact_father_status : "-",
      ]);

      // มารดา
      DataForExcel.push([]);
      DataForExcel.push(["มารดา"]);
      DataForExcel.push([
        "คำนำหน้า (TH)",
        "ชื่อ (TH)",
        "นามสกุล (TH)",
        "สถานภาพ",
      ]);
      DataForExcel.push([
        data.contact_mother_prefix_name ? data.contact_mother_prefix_name : "-",
        data.contact_mother_firstname ? data.contact_mother_firstname : "-",
        data.contact_mother_lastname ? data.contact_mother_lastname : "-",
        data.contact_mother_status ? data.contact_mother_status : "-",
      ]);

      // คู่สมรส
      DataForExcel.push([]);
      DataForExcel.push(["คู่สมรส"]);
      DataForExcel.push(["สถานภาพ", "ชื่อ (TH)", "นามสกุล (TH)"]);
      DataForExcel.push([
        data.contact_spouse_status ? data.contact_spouse_status : "-",
        data.contact_spouse_firstname ? data.contact_spouse_firstname : "-",
        data.contact_spouse_lastname ? data.contact_spouse_lastname : "-",
      ]);

      // จำนวนบุตร
      DataForExcel.push([]);
      DataForExcel.push(["จำนวนบุตร"]);
      DataForExcel.push(["ชื่อ", "นามสกุล", "เพศ", "อายุ"]);
      data.childern?.map((data: any) => {
        DataForExcel.push([
          data.first_name ? data.first_name : "-",
          data.last_name ? data.last_name : "-",
          data.gender ? (data.gender === "MALE" ? "ชาย" : "หญิง") : "-",
          data.birthday ? getAge(data.birthday) : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "รายละเอียดครอบครัว");
    }

    // ประวัติการเปลี่ยนชื่อ
    if (isCheckedRename) {
      DataForExcel = [];

      DataForExcel.push(["ชื่อ", "นามสกุล", "วันที่เปลี่ยนแปลง", "เหตุผล"]);
      data.name_change_histories?.map((data: any) => {
        DataForExcel.push([
          data.first_name ? data.first_name : "-",
          data.last_name ? data.last_name : "-",
          data.date
            ? Moment(data.date).add(543, "year").format("DD/MM/YYYY")
            : "-",
          data.reason ? data.reason : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ประวัติการเปลี่ยนชื่อ");
    }

    // ประวัติการศึกษา
    if (isCheckedEducation) {
      DataForExcel = [];

      DataForExcel.push(["ชื่อ", "ระดับ", "สาขาวิชา", "ปีที่สำเร็จการศึกษา"]);
      data.education_histories?.toReversed().map((data: any) => {
        DataForExcel.push([
          data.school_name ? data.school_name : "-",
          data.graduation_level ? data.graduation_level : "-",
          data.graduation_major ? data.graduation_major : "-",
          data.graduation_year ? data.graduation_year : "-",
        ]);
      });

      const wsHistory = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, wsHistory, "ประวัติการศึกษา");
    }

    // ประวัติการฝึกอบรม
    if (isCheckedTraining) {
      DataForExcel = [];

      DataForExcel.push([
        "หลักสูตร",
        "ประเภทการฝึกอบรม",
        "ปี",
        "สถาบัน / ประเทศ",
      ]);
      data.training_histories?.map((data: any) => {
        DataForExcel.push([
          data.course ? data.course : "-",
          data.course_type ? data.course_type : "-",
          data.year ? data.year : "-",
          data.location ? data.location : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ประวัติการฝึกอบรม");
    }

    // ประวัติเครื่องราชอิสริยาภรณ์
    if (isCheckedInsignia) {
      DataForExcel = [];

      DataForExcel.push([
        "ประจำปี",
        "วันที่ได้รับเครื่องราชย์",
        "ประเภท",
        "เครื่องราชอิสริยาภรณ์",
      ]);
      data.insignia_histories?.map((data: any) => {
        DataForExcel.push([
          data.year ? data.year : "-",
          data.date_of_award
            ? Moment(data.date_of_award).add(543, "year").format("DD/MM/YYYY")
            : "-",
          data.type ? data.type : "-",
          data.name ? data.name : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ประวัติเครื่องราชอิสริยาภรณ์");
    }

    // ประวัติการลงโทษ
    if (isCheckedPunishment) {
      DataForExcel = [];

      DataForExcel.push(["เลขที่คำสั่ง", "เรื่อง", "วันที่"]);
      data.punishment_histories?.map((data: any) => {
        DataForExcel.push([
          data.order_no ? data.order_no : "-",
          data.name ? data.name : "-",
          data.date
            ? Moment(data.date).add(543, "year").format("DD/MM/YYYY")
            : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ประวัติการลงโทษ");
    }

    // ผลงานดีเด่น/รางวัล
    if (isCheckedOutstandingAwards) {
      DataForExcel = [];

      DataForExcel.push(["ประจำปี", "ผลงานดีเด่น"]);
      data.outstanding_performance_awards?.map((data: any) => {
        DataForExcel.push([
          data.year ? data.year : "-",
          data.name ? data.name : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ผลงานดีเด่น-รางวัล");
    }

    // ประวัติการลาออก / เกษียณอายุ / เสียชีวิต
    if (isCheckedResignationRetireDeath) {
      DataForExcel = [];

      DataForExcel.push(["คำสั่ง อตก. ที่", "สั่ง ณ วันที่", "สถานะ"]);
      data.resignation_retirement_death_histories?.map((data: any) => {
        DataForExcel.push([
          data.order_no ? data.order_no : "-",
          data.date
            ? Moment(data.date).add(543, "year").format("DD/MM/YYYY")
            : "-",
          data.status ? data.status : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ประวัติลาออก-เกษียณ-เสียชีวิต");
    }

    // ผู้รับรองการเข้าทำงาน
    if (isCheckedCertifier) {
      DataForExcel = [];

      DataForExcel.push(["ชื่อ-สกุล", "ความสัมพันธ์", "ตำแหน่ง"]);
      data.employee_certifiers?.map((data: any) => {
        DataForExcel.push([
          data.name ? data.name : "-",
          data.relationship ? data.relationship : "-",
          data.position ? data.position : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ผู้รับรองการเข้าทำงาน");
    }

    // ประวัติการทำงาน ของ อตก.
    if (isCheckedWorkOrtokor) {
      DataForExcel = [];

      DataForExcel.push([
        "ประเภทบุคคลากร",
        "ระดับตำแหน่ง",
        "ตำแหน่ง",
        "ลักษณะตำแหน่ง",
        "วันที่เริ่มงาน",
        "วันที่สิ้นสุด",
      ]);
      data.mof_work_histories?.toReversed().map((data: any) => {
        DataForExcel.push([
          data.employee_type ? data.employee_type : "-",
          data.position_level ? data.position_level : "-",
          data.position_name ? data.position_name : "-",
          data.position_type ? data.position_type : "-",
          data.start_date
            ? Moment(data.start_date).add(543, "year").format("DD/MM/YYYY")
            : "-",
          data.end_date
            ? Moment(data.end_date).add(543, "year").format("DD/MM/YYYY")
            : data.is_currently === 1
              ? "ปัจจุบัน"
              : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ประวัติการทำงาน ของ อตก");
    }

    // ประวัติการทำงานที่ผ่านมา
    if (isCheckedWorkHistory) {
      DataForExcel = [];

      DataForExcel.push([
        "สถานที่ทำงาน",
        "วันที่เริ่มต้น-สิ้นสุด",
        "อายุงาน",
        "ตำแหน่ง",
        "เงินเดือน",
        "เหตุผลที่ลาออก",
      ]);
      data.work_histories?.map((data: any) => {
        DataForExcel.push([
          data.location ? data.location : "-",
          data.start_date
            ? Moment(data.start_date).add(543, "year").format("DD/MM/YYYY")
            : "-" + " - " + data.end_date
              ? Moment(data.end_date).add(543, "year").format("DD/MM/YYYY")
              : "-",
          data.start_date && data.end_date
            ? getDateDiff(data.start_date, data.end_date)
            : "-",
          data.position ? data.position : "-",
          data.salary ? addCommas(data.salary) : "-",
          data.reason ? data.reason : "-",
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(DataForExcel);
      XLSX.utils.book_append_sheet(wb, ws, "ประวัติการทำงานที่ผ่านมา");
    }

    if (Object.keys(wb.Sheets).length > 0) {
      XLSX.writeFile(wb, "ทะเบียนประวัติบุคลากร.xlsx");
    }
  };

  function addCommas(number: any) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function displayPhoto() {
    if (data.photo === "" || data.photo === null) {
      return <img src="/static/no-image.png" alt="not photo image" />;
    } else {
      return (
        <img
          className="employee-photo object-fit-cover"
          src={getMediaPath(data.photo)}
          alt="photo image"
        />
      );
    }
  }

  const PDF = () => {
    const normalizeText = (value: any) =>
      value ? String(value).replace(/\s+/g, " ").trim() : "";

    const getThaiDateTime = () => {
      const now = new Date();
      const thaiMonths = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      const day = now.getDate();
      const month = thaiMonths[now.getMonth()];
      const year = now.getFullYear() + 543;
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${day} ${month} ${year} ${hours}:${minutes}`;
    };

    // ถือว่าเป็นตำแหน่งปัจจุบันเมื่อ:
    //   1) is_currently เป็น true/1/"1" (รองรับทั้ง BOOLEAN และ TINYINT จาก raw query) หรือ
    //   2) ไม่มี end_date เลย (ตำแหน่งที่จบแล้วต้องมีวันสิ้นสุดเสมอ)
    const isCurrentPosition = (item: any) => {
      if (!item) return false;
      const flag = item.is_currently;
      if (
        flag === true ||
        flag === 1 ||
        flag === "1" ||
        flag === "true"
      ) {
        return true;
      }
      const endDate = item.end_date;
      return endDate === null || endDate === undefined || endDate === "";
    };

    const workHistories =
      data.mof_work_histories
        ?.filter((h: any) => h.order_no != null)
        .toReversed() ?? [];

    // คำนวณ budget แถวของหน้า โดยหัก section อื่นที่อยู่ก่อนประวัติการทำงาน
    // (ทุก section ที่มี placeholder '-' จะกินอย่างน้อย 1 แถวเสมอ)
    const countSectionRows = (arr: any) =>
      Math.max(1, Array.isArray(arr) ? arr.length : 0);

    const variableRowsFirstPage =
      (data.name_change_histories?.length ?? 0) +
      countSectionRows(data.education_histories) +
      countSectionRows(data.insignia_histories) +
      countSectionRows(data.resignation_retirement_death_histories) +
      countSectionRows(data.punishment_histories);

    const variableRowsOverflowPage =
      countSectionRows(data.education_histories) +
      countSectionRows(data.insignia_histories) +
      countSectionRows(data.resignation_retirement_death_histories) +
      countSectionRows(data.punishment_histories);

    // FIRST_PAGE_BUDGET = budget รวมของ section ผันแปร + ประวัติการทำงาน ในหน้าที่มีตารางงาน
    // OVERFLOW_PAGE_BUDGET = หน้าต่อที่มีรูป/หัวข้อซ้ำ จึงเหลือพื้นที่ตารางน้อยกว่าเล็กน้อย
    // ค่านี้เป็นหน่วย "บรรทัด" (ชื่อตำแหน่งสั้น=1 ยาว=2-3) ไม่ใช่จำนวนตำแหน่งคงที่
    const FIRST_PAGE_BUDGET = 28;
    const OVERFLOW_PAGE_BUDGET = 32;

    // ประมาณจำนวนบรรทัดที่ record จะกินจริง (ตาม logic ตัดบรรทัดตอน render)
    // เพื่อ pack ใส่หน้าให้เต็มพื้นที่มากที่สุด แทนการตัดด้วยจำนวนตำแหน่งคงที่
    const estimateWorkHistoryLineCount = (item: any) => {
      const positionName = normalizeText(item.position_name);
      const positionText = positionName
        ? `${positionName} (${item.order_no})`
        : "";
      let positionLines = 1;
      if (positionText.length > 40) positionLines = 3;
      else if (positionText.length > 25) positionLines = 2;

      const typeText = item.position_type ? String(item.position_type) : "";
      let typeLines = 1;
      if (typeText.length > 20) typeLines = 3;
      else if (typeText.length > 10) typeLines = 2;

      const startDate = item.start_date
        ? Moment(item.start_date).add(543, "year").format("DD/MM/YYYY")
        : "";
      const endDate = isCurrentPosition(item)
        ? "ปัจจุบัน"
        : item.end_date
          ? Moment(item.end_date).add(543, "year").format("DD/MM/YYYY")
          : "";
      const dateLines = `${startDate} - ${endDate}`.length > 25 ? 2 : 1;

      return Math.max(positionLines, typeLines, dateLines);
    };

    const packWorkHistoriesByLineBudget = (
      items: any[],
      lineBudget: number,
    ) => {
      const pages: any[][] = [];
      let current: any[] = [];
      let usedLines = 0;

      for (const item of items) {
        const cost = estimateWorkHistoryLineCount(item);
        if (current.length > 0 && usedLines + cost > lineBudget) {
          pages.push(current);
          current = [item];
          usedLines = cost;
        } else {
          current.push(item);
          usedLines += cost;
        }
      }
      if (current.length > 0) pages.push(current);
      return pages;
    };

    const workHistoryLineBudgetFirstPage = Math.max(
      10,
      FIRST_PAGE_BUDGET - variableRowsFirstPage,
    );
    const workHistoryLineBudgetOverflowPage = Math.max(
      14,
      OVERFLOW_PAGE_BUDGET - variableRowsOverflowPage,
    );

    // A4 content ~575pt, ภูมิลำเนา cell 66.66% ≈ 380pt, fontSize 10 ≈ ~55-60 ตัวอักษร/บรรทัด
    const domicileAddressText = data.address_official
      ? `${data.address_official} ต.${data.official_tambon?.name_th ?? ""} อ.${data.official_amphure?.name_th ?? ""} จ.${data.official_province?.name_th ?? ""}`
      : "";
    const domicileAddressWraps =
      `ที่อยู่ตามบัตรประชาชน ${domicileAddressText}`.length > 70;

    const firstPageRecords: any[] = [];
    let firstPageUsedLines = 0;
    let firstPageEndIndex = 0;
    for (let i = 0; i < workHistories.length; i++) {
      const cost = estimateWorkHistoryLineCount(workHistories[i]);
      if (
        firstPageRecords.length > 0 &&
        firstPageUsedLines + cost > workHistoryLineBudgetFirstPage
      ) {
        break;
      }
      firstPageRecords.push(workHistories[i]);
      firstPageUsedLines += cost;
      firstPageEndIndex = i + 1;
    }
    const overflowRecords = workHistories.slice(firstPageEndIndex);
    const overflowChunks = packWorkHistoriesByLineBudget(
      overflowRecords,
      workHistoryLineBudgetOverflowPage,
    );

    return (
      <Document>
        {/* Page1 */}
        <Page size="A4" style={{ padding: 10 }}>
          <View>
            <View
              style={{
                fontFamily: "kanit-regular",
                borderBottomWidth: 1,
                marginBottom: 10,
              }}
              fixed
            >
              <View style={{ flexDirection: "row" }}>
                <Text style={{ fontSize: 15, textAlign: "left", width: "50%" }}>
                  รายงานประวัติบุคลากร <Text></Text>
                </Text>
                <Text
                  style={{
                    fontSize: 10,
                    textAlign: "right",
                    width: "50%",
                    alignSelf: "flex-end",
                  }}
                  render={({ pageNumber, totalPages }) =>
                    `หน้าที่ ${pageNumber} / ${totalPages - 1}`
                  }
                />
              </View>
            </View>

            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <View style={{ width: "87%" }}>
                <View style={{ flexDirection: "row", marginBottom: 3 }}>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "35%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    รหัสพนักงาน{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.code ? data.code : ""} <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    เพศ{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.gender
                        ? data.gender === "MALE"
                          ? "ชาย"
                          : "หญิง"
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                </View>
                <View style={{ flexDirection: "row", marginBottom: 3 }}>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "35%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ชื่อต้น{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.prefix_name_th ? data.prefix_name_th : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "32.5%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ชื่อ{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.firstname_th ? data.firstname_th : ""} <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "32.5%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ชื่อสกุล{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.lastname_th ? data.lastname_th : ""} <Text></Text>
                    </Text>
                  </Text>
                </View>
                <View style={{ flexDirection: "row", marginBottom: 3 }}>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ชื่อภาษาอังกฤษ{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.prefix_name_en ? data.prefix_name_en : ""}
                      {data.firstname_en ? data.firstname_en : ""}{" "}
                      {data.lastname_en ? data.lastname_en : ""} <Text></Text>
                    </Text>
                  </Text>
                </View>
                <View style={{ flexDirection: "row", marginBottom: 3 }}>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "35%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    เลขประจำตัวผู้เสียภาษี{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.id_card ? data.id_card : ""} <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "32.5%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    วันเดือนปีเกิด{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.birthday
                        ? Moment(data.birthday)
                            .add(543, "year")
                            .format("DD/MM/YYYY")
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "32.5%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    อายุ{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.birthday ? getAge(data.birthday) : ""} <Text></Text>
                    </Text>
                  </Text>
                </View>
              </View>
              <View style={{ width: "13%" }}>
                <Image
                  src={
                    data.photo
                      ? getMediaPath(data.photo)
                      : "/static/no-image.png"
                  }
                  style={{
                    width: 72,
                    height: 82,
                    objectFit: "cover",
                    alignSelf: "flex-end",
                    borderRadius: 5,
                  }}
                />
              </View>
            </View>

            <View
              style={{
                borderLeftWidth: 1,
                borderTopWidth: 1,
                borderRightWidth: 1,
                borderBottomWidth: 1,
                marginBottom: 10,
              }}
            >
              <View style={{ flexDirection: "row" }}>
                <View
                  style={{
                    width: "33.33%",
                    borderRightWidth: 1,
                    paddingLeft: 5,
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    เลขที่บัตรประชาชน{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.id_card ? data.id_card : ""} <Text></Text>
                    </Text>
                  </Text>
                </View>
                <View
                  style={{
                    width: "33.33%",
                    borderRightWidth: 1,
                    paddingLeft: 5,
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    วันหมดอายุ{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.id_card_date_expire
                        ? Moment(data.id_card_date_expire)
                            .add(543, "year")
                            .format("DD/MM/YYYY")
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                </View>
                <View
                  style={{
                    width: "33.34%",
                    paddingLeft: 5,
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ออกให้ ณ{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.id_card_date_generate
                        ? Moment(data.id_card_date_generate)
                            .add(543, "year")
                            .format("DD/MM/YYYY")
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                </View>
              </View>
              <View style={{ flexDirection: "row", borderTopWidth: 1 }}>
                <View
                  style={{
                    width: "66.66%",
                    borderRightWidth: 1,
                    paddingLeft: 5,
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ที่อยู่ตามบัตรประชาชน{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {domicileAddressText} <Text></Text>
                    </Text>
                    {domicileAddressWraps ? " " : "\n"}
                    ไปรษณีย์{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.postcode_official ? data.postcode_official : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                </View>
                <View style={{ width: "33.34%" }}>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      paddingLeft: 5,
                      paddingTop: 2,
                      paddingBottom: 1,
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "kanit-regular",
                        fontSize: 10,
                        textAlign: "left",
                      }}
                    >
                      โทรศัพท์{" "}
                      <Text style={{ fontFamily: "kanit-200" }}>
                        {data.phone ? data.phone : ""} <Text></Text>
                      </Text>
                    </Text>
                  </View>
                  <View
                    style={{
                      paddingLeft: 5,
                      paddingTop: 2,
                      paddingBottom: 1,
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "kanit-regular",
                        fontSize: 10,
                        textAlign: "left",
                      }}
                    >
                      อีเมล{" "}
                      <Text style={{ fontFamily: "kanit-200" }}>
                        {data.user?.email ? data.user?.email : ""}{" "}
                        <Text></Text>
                      </Text>
                    </Text>
                  </View>
                </View>
              </View>
              <View style={{ flexDirection: "row", borderTopWidth: 1 }}>
                <View
                  style={{
                    width: "33.33%",
                    borderRightWidth: 1,
                    paddingLeft: 5,
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    เชื้อชาติ{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.ethnicity ? data.ethnicity : ""} <Text></Text>
                    </Text>
                  </Text>
                </View>
                <View
                  style={{
                    width: "33.33%",
                    borderRightWidth: 1,
                    paddingLeft: 5,
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    สัญชาติ{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.nationality ? data.nationality : ""} <Text></Text>
                    </Text>
                  </Text>
                </View>
                <View
                  style={{
                    width: "33.34%",
                    paddingLeft: 5,
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ศาสนา{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.religion ? data.religion : ""} <Text></Text>
                    </Text>
                  </Text>
                </View>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  borderTopWidth: 1,
                  paddingTop: 2,
                  paddingBottom: 1,
                }}
              >
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  หมู่เลือด{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.blood_type ? data.blood_type : ""} <Text></Text>
                  </Text>
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  borderTopWidth: 1,
                  paddingTop: 2,
                  paddingBottom: 1,
                }}
              >
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ชื่อบิดา{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.contact_father_prefix_name
                      ? data.contact_father_prefix_name
                      : ""}
                    {data.contact_father_firstname
                      ? data.contact_father_firstname
                      : ""}{" "}
                    {data.contact_father_lastname
                      ? data.contact_father_lastname
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  paddingTop: 2,
                  paddingBottom: 1,
                }}
              >
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ชื่อมารดา{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.contact_mother_prefix_name
                      ? data.contact_mother_prefix_name
                      : ""}
                    {data.contact_mother_firstname
                      ? data.contact_mother_firstname
                      : ""}{" "}
                    {data.contact_mother_lastname
                      ? data.contact_mother_lastname
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
              </View>
              <View style={{ flexDirection: "row", borderTopWidth: 1 }}>
                <View
                  style={{
                    flexDirection: "column",
                    width: "50%",
                    borderRightWidth: 1,
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    ที่อยู่ปัจจุบัน{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.address_contactable
                        ? `${data.address_contactable} ต.${data.contactable_tambon?.name_th} อ.${data.contactable_amphure?.name_th} จ.${data.contactable_province?.name_th} `
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    ไปรษณีย์{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.postcode_contactable
                        ? data.postcode_contactable
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    โทรศัพท์{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.phone ? data.phone : ""} <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    อีเมล{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.user?.email ? data.user?.email : ""} <Text></Text>
                    </Text>
                  </Text>
                </View>
                <View
                  style={{
                    flexDirection: "column",
                    width: "50%",
                    paddingTop: 2,
                    paddingBottom: 1,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    กรณีฉุกเฉินติดต่อ{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.emergency_contact_full_name
                        ? data.emergency_contact_full_name
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    ความสัมพันธ์{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.emergency_contact_relationship
                        ? data.emergency_contact_relationship
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    ที่อยู่{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.emergency_contact_address
                        ? `${data.emergency_contact_address} ต.${data.emergency_contact_tambon?.name_th} อ.${data.emergency_contact_amphure?.name_th} จ.${data.emergency_contact_province?.name_th} `
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    ไปรษณีย์{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.emergency_contact_postcode
                        ? data.emergency_contact_postcode
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    โทรศัพท์{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.emergency_contact_tel
                        ? data.emergency_contact_tel
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                  </Text>
                </View>
              </View>
              <View style={{ flexDirection: "column", borderTopWidth: 1 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ประวัติการศึกษา <Text></Text>
                </Text>
                <>
                  {data.education_histories
                    ?.toReversed()
                    .map((data: any, index: any) => {
                      return (
                        <>
                          <View style={{ flexDirection: "row" }}>
                            <Text
                              style={{
                                fontFamily: "kanit-regular",
                                width: "20%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {index + 1}.{" "}
                              <Text style={{ fontFamily: "kanit-200" }}>
                                {data.graduation_level
                                  ? data.graduation_level
                                  : "-"}{" "}
                                <Text></Text>
                              </Text>
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-regular",
                                width: "60%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              จาก{" "}
                              <Text style={{ fontFamily: "kanit-200" }}>
                                {data.school_name ? data.school_name : "-"}{" "}
                                <Text></Text>
                              </Text>
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-regular",
                                width: "20%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              ปี{" "}
                              <Text style={{ fontFamily: "kanit-200" }}>
                                {data.graduation_year
                                  ? data.graduation_year
                                  : "-"}{" "}
                                <Text></Text>
                              </Text>
                            </Text>
                          </View>
                        </>
                      );
                    })}
                </>
              </View>
              <View style={{ flexDirection: "row" }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "33.3%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ตำแหน่งงานปัจจุบัน{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.current_job_position?.position_name
                      ? data.current_job_position?.position_name
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "33.3%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  กอง/กลุ่ม/สำนักงาน{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.current_job_position?.division_group_office_name
                      ? data.current_job_position?.division_group_office_name
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "33.3%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ฝ่าย/สำนัก{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.current_job_position?.department_offices_name
                      ? data.current_job_position?.department_offices_name
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
              </View>
            </View>

            <Text
              style={{
                fontFamily: "kanit-regular",
                fontSize: 10,
                borderBottomWidth: 1,
                marginBottom: 5,
              }}
            >
              รายละเอียดเงินเดือน <Text></Text>
            </Text>

            <View style={{ marginBottom: 10 }}>
              <View style={{ flexDirection: "row", marginBottom: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  ฝ่าย{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.current_job_position?.department_offices_name
                      ? data.current_job_position?.department_offices_name
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  กอง{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.current_job_position?.division_group_office_name
                      ? data.current_job_position?.division_group_office_name
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  แผนก{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.current_job_position?.structure_departments_name
                      ? data.current_job_position?.structure_departments_name
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  ตำแหน่ง{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.current_job_position?.position_name
                      ? data.current_job_position?.position_name
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
              </View>
              <View style={{ flexDirection: "row", marginBottom: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  {data.mof_work_histories
                    ?.filter((h: any) => h.order_no != null)
                    .map((data: any, index: any) => {
                      if (index === 0) {
                        return (
                          <>
                            ครองระดับ(ล่าสุด){" "}
                            <Text style={{ fontFamily: "kanit-200" }}>
                              {data.tenure_position_date
                                ? Moment(data.tenure_position_date)
                                    .add(543, "year")
                                    .format("DD/MM/YYYY")
                                : ""}{" "}
                              <Text></Text>
                            </Text>
                          </>
                        );
                      }
                    })}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  {data.mof_work_histories
                    ?.filter((h: any) => h.order_no != null)
                    .map((data: any, index: any) => {
                      if (index === 0) {
                        return (
                          <>
                            วันที่เริ่มงาน{" "}
                            <Text style={{ fontFamily: "kanit-200" }}>
                              {data.start_date
                                ? Moment(data.start_date)
                                    .add(543, "year")
                                    .format("DD/MM/YYYY")
                                : ""}{" "}
                              <Text></Text>
                            </Text>
                          </>
                        );
                      }
                    })}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  {data.mof_work_histories
                    ?.filter((h: any) => h.order_no != null)
                    ?.toReversed()
                    .map((data: any, index: any) => {
                      if (index === 0) {
                        return (
                          <>
                            วันที่บรรจุ{" "}
                            <Text style={{ fontFamily: "kanit-200" }}>
                              {data.start_date
                                ? Moment(data.start_date)
                                    .add(543, "year")
                                    .format("DD/MM/YYYY")
                                : ""}{" "}
                              <Text></Text>
                            </Text>
                          </>
                        );
                      }
                    })}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  {data.mof_work_histories
                    ?.filter((h: any) => h.order_no != null)
                    ?.toReversed()
                    .map((data: any, index: any) => {
                      if (index === 0) {
                        return (
                          <>
                            อายุงาน{" "}
                            <Text style={{ fontFamily: "kanit-200" }}>
                              {data.start_date
                                ? getDateDiff(
                                    data.start_date,
                                    new Date().toISOString(),
                                  )
                                : ""}{" "}
                              <Text></Text>
                            </Text>
                          </>
                        );
                      }
                    })}
                </Text>
              </View>
              <View style={{ flexDirection: "row", marginBottom: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  ประเภทพนักงาน{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.current_job_position?.employee_type
                      ? data.current_job_position?.employee_type
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
              </View>
              <View style={{ flexDirection: "row", marginBottom: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  อัตราเงินเดือน{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.salary ? addCommas(data.salary) : "-"} <Text></Text>
                  </Text>{" "}
                  บาทต่อเดือน
                </Text>
              </View>
            </View>
          </View>
        </Page>

        {/* Page2 */}
        <Page size="A4" style={{ padding: 10 }}>
          <View>
            <Text
              style={{
                fontFamily: "kanit-regular",
                fontSize: 15,
                textAlign: "center",
                marginBottom: 10,
              }}
            >
              ข้อมูลประวัติการทำงาน <Text></Text>
            </Text>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "25%",
                  fontSize: 10,
                  textAlign: "left",
                }}
              >
                รหัสพนักงาน{" "}
                <Text style={{ fontFamily: "kanit-200" }}>
                  {data.code ? data.code : "-"} <Text></Text>
                </Text>
              </Text>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "50%",
                  fontSize: 10,
                  textAlign: "center",
                }}
              >
                {data.prefix_name_th ? data.prefix_name_th : ""}{" "}
                {data.firstname_th ? data.firstname_th : ""}{" "}
                {data.lastname_th ? data.lastname_th : ""}
              </Text>
              <Text style={{ width: "25%" }}></Text>
            </View>

            {/* <View style={{ flexDirection: "row", marginBottom: 3 }}>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "33.3%",
                  fontSize: 10,
                  textAlign: "left",
                }}
              >
                ตำแหน่งปัจจุบัน{" "}
                <Text style={{ fontFamily: "kanit-200" }}>
                  {data.current_job_position?.position_name
                    ? data.current_job_position?.position_name
                    : ""}{" "}
                  <Text></Text>
                </Text>
              </Text>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "33.3%",
                  fontSize: 10,
                  textAlign: "left",
                }}
              >
                กอง{" "}
                <Text style={{ fontFamily: "kanit-200" }}>
                  {data.current_job_position?.division_group_office_name
                    ? data.current_job_position?.division_group_office_name
                    : ""}{" "}
                  <Text></Text>
                </Text>
              </Text>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "33.3%",
                  fontSize: 10,
                  textAlign: "left",
                }}
              >
                ฝ่าย{" "}
                <Text style={{ fontFamily: "kanit-200" }}>
                  {data.current_job_position?.department_offices_name
                    ? data.current_job_position?.department_offices_name
                    : ""}{" "}
                  <Text></Text>
                </Text>
              </Text>
              
            </View> */}

            <View style={{ marginBottom: 10 }}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <View style={{ flex: 1 }}>
                  <View
                    style={{ flexDirection: "row", justifyContent: "flex-end" }}
                  >
                    <Image
                      src={
                        data.photo
                          ? getMediaPath(data.photo)
                          : "/static/no-image.png"
                      }
                      style={{
                        width: 85,
                        height: 95,
                        objectFit: "cover",
                        borderRadius: 5,
                      }}
                    />
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "flex-end",
                      marginTop: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "kanit-regular",
                        fontSize: 10,
                      }}
                    >
                      เกษียณอายุในปี{" "}
                      <Text style={{ fontFamily: "kanit-200" }}>
                        {data.birthday
                          ? (() => {
                              const birthMoment = Moment(data.birthday);
                              const retirementYear =
                                parseInt(
                                  Moment(data.birthday)
                                    .add(543, "year")
                                    .format("YYYY"),
                                ) + 60;
                              const month = birthMoment.month();
                              const day = birthMoment.date();
                              // เกิดตั้งแต่ 2 ต.ค. เป็นต้นไป (รวม พ.ย./ธ.ค.) → +1 ปี
                              // เพราะปีงบประมาณไทยสิ้นสุด 30 ก.ย. คนที่อายุครบ 60
                              // หลังวันที่ 1 ต.ค. จะอยู่ในปีงบประมาณถัดไป
                              const addOne =
                                month > 9 || (month === 9 && day >= 2);
                              return retirementYear + (addOne ? 1 : 0);
                            })()
                          : ""}{" "}
                        <Text></Text>
                      </Text>
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      marginTop: 5,
                    }}
                  >
                    <Text style={{ fontFamily: "kanit-regular", fontSize: 10 }}>
                      ตำแหน่งปัจจุบัน{" "}
                      <Text style={{ fontFamily: "kanit-200" }}>
                        {data.current_job_position?.position_name || ""}{" "}
                        <Text></Text>
                      </Text>
                    </Text>
                  </View>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      marginTop: 5,
                    }}
                  >
                    อัตราเงินเดือนปัจจุบัน{" "}
                    <Text style={{ fontFamily: "kanit-200" }}>
                      {data.salary ? addCommas(data.salary) : "-"} <Text></Text>
                    </Text>{" "}
                    บาท
                  </Text>
                </View>
              </View>
              <View style={{ flexDirection: "row" }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "33.3%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  วันเดือนปีเกิด{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.birthday
                      ? Moment(data.birthday)
                          .add(543, "year")
                          .format("DD/MM/YYYY")
                      : ""}{" "}
                    <Text></Text>
                  </Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "33.3%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  อายุ{" "}
                  <Text style={{ fontFamily: "kanit-200" }}>
                    {data.birthday ? getAge(data.birthday) : ""} <Text></Text>
                  </Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "33.3%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  {" "}
                  {/* <Text style={{ fontFamily: "kanit-200" }}>
                  {data.birthday
                    ? parseInt(
                        Moment(data.birthday).add(543, "year").format("YYYY")
                      ) + 60
                    : ""}{" "}
                  <Text></Text>
                </Text> */}
                </Text>
              </View>
              <View style={{ flexDirection: "row", marginBottom: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "50%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  {data.mof_work_histories
                    ?.toReversed()
                    .map((data: any, index: any) => {
                      if (index === 0) {
                        return (
                          <>
                            บรรจุเข้าทำงานเมื่อวันที่{" "}
                            <Text style={{ fontFamily: "kanit-200" }}>
                              {data.start_date
                                ? Moment(data.start_date)
                                    .add(543, "year")
                                    .format("DD/MM/YYYY")
                                : ""}{" "}
                              <Text></Text>
                            </Text>
                          </>
                        );
                      }
                    })}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "50%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  {data.mof_work_histories
                    ?.toReversed()
                    .map((data: any, index: any) => {
                      if (index === 0) {
                        return (
                          <>
                            อายุงาน{" "}
                            <Text style={{ fontFamily: "kanit-200" }}>
                              {data.start_date
                                ? getDateDiff(
                                    data.start_date,
                                    new Date().toISOString(),
                                  )
                                : ""}{" "}
                              <Text></Text>
                            </Text>
                          </>
                        );
                      }
                    })}
                </Text>
              </View>
              <View style={{ flexDirection: "row", marginBottom: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "50%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  {/* {data.mof_work_histories?.map((data: any, index: any) => {
                  if (index === 0) {
                    return (
                      <>
                        ครองระดับในตำแหน่งปัจจุบันเมื่อวันที่{" "}
                        <Text style={{ fontFamily: "kanit-200" }}>
                          {data.start_date
                            ? Moment(data.start_date)
                                .add(543, "year")
                                .format("DD/MM/YYYY")
                            : ""}{" "}
                          <Text></Text>
                        </Text>
                      </>
                    );
                  }
                })} */}
                  {data.current_job_position?.employee_type ===
                    "ลูกจ้างประจำ" &&
                    (() => {
                      const reversedHistories = data.mof_work_histories
                        ?.filter((item: any) => item.order_no != null)
                        .toReversed();
                      const latestLevel =
                        reversedHistories?.[0]?.position_level;
                      let targetHistory = reversedHistories?.[0];

                      if (latestLevel && reversedHistories) {
                        // หาตำแหน่งก่อนหน้าที่มี level เดียวกับ level ล่าสุด
                        for (
                          let i = reversedHistories.length - 1;
                          i >= 0;
                          i--
                        ) {
                          if (
                            reversedHistories[i]?.position_level === latestLevel
                          ) {
                            targetHistory = reversedHistories[i];
                            break;
                          }
                        }
                      }

                      return targetHistory ? (
                        <>
                          ครองระดับในตำแหน่งปัจจุบันเมื่อวันที่{" "}
                          <Text style={{ fontFamily: "kanit-200" }}>
                            {targetHistory.start_date
                              ? Moment(targetHistory.start_date)
                                  .add(543, "year")
                                  .format("DD/MM/YYYY")
                              : ""}{" "}
                            <Text></Text>
                          </Text>
                        </>
                      ) : null;
                    })()}

                  {data.current_job_position?.employee_type === "พนักงาน" &&
                    (() => {
                      const histories = data.mof_work_histories.filter(
                        (item: any) => item.order_no != null,
                      );
                      const latestLevel = histories?.[0]?.position_level;
                      let targetHistory = histories?.[0];

                      if (latestLevel && histories) {
                        // หาตำแหน่งก่อนหน้าที่มี level เดียวกับ level ล่าสุด
                        for (let i = histories.length - 1; i >= 0; i--) {
                          if (histories[i]?.position_level === latestLevel) {
                            targetHistory = histories[i];
                            break;
                          }
                        }
                      }

                      return targetHistory ? (
                        <>
                          ครองระดับในตำแหน่งปัจจุบันเมื่อวันที่{" "}
                          <Text style={{ fontFamily: "kanit-200" }}>
                            {targetHistory.start_date
                              ? Moment(targetHistory.start_date)
                                  .add(543, "year")
                                  .format("DD/MM/YYYY")
                              : ""}{" "}
                            <Text></Text>
                          </Text>
                        </>
                      ) : null;
                    })()}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "50%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  {data.current_job_position?.employee_type ===
                    "ลูกจ้างประจำ" &&
                    (() => {
                      const reversedHistories = data.mof_work_histories
                        ?.filter((item: any) => item.order_no != null)
                        .toReversed();
                      const latestLevel =
                        reversedHistories?.[0]?.position_level;
                      let targetHistory = reversedHistories?.[0];

                      if (latestLevel && reversedHistories) {
                        // หาตำแหน่งก่อนหน้าที่มี level เดียวกับ level ล่าสุด
                        for (
                          let i = reversedHistories.length - 1;
                          i >= 0;
                          i--
                        ) {
                          if (
                            reversedHistories[i]?.position_level === latestLevel
                          ) {
                            targetHistory = reversedHistories[i];
                            break;
                          }
                        }
                      }

                      return targetHistory ? (
                        <>
                          อายุงาน{" "}
                          <Text style={{ fontFamily: "kanit-200" }}>
                            {targetHistory.start_date
                              ? getDateDiff(
                                  targetHistory.start_date,
                                  new Date().toISOString(),
                                )
                              : ""}{" "}
                            <Text></Text>
                          </Text>
                        </>
                      ) : null;
                    })()}

                  {data.current_job_position?.employee_type === "พนักงาน" &&
                    (() => {
                      const histories = data.mof_work_histories.filter(
                        (item: any) => item.order_no != null,
                      );
                      const latestLevel = histories?.[0]?.position_level;
                      let targetHistory = histories?.[0];

                      if (latestLevel && histories) {
                        // หาตำแหน่งก่อนหน้าที่มี level เดียวกับ level ล่าสุด
                        for (let i = histories.length - 1; i >= 0; i--) {
                          if (histories[i]?.position_level === latestLevel) {
                            targetHistory = histories[i];
                            break;
                          }
                        }
                      }

                      return targetHistory ? (
                        <>
                          อายุงาน{" "}
                          <Text style={{ fontFamily: "kanit-200" }}>
                            {targetHistory.start_date
                              ? getDateDiff(
                                  targetHistory.start_date,
                                  new Date().toISOString(),
                                )
                              : ""}{" "}
                            <Text></Text>
                          </Text>
                        </>
                      ) : null;
                    })()}
                </Text>
              </View>
            </View>

            <View
              style={{
                borderLeftWidth: 1,
                borderTopWidth: 1,
                borderRightWidth: 1,
                borderBottomWidth: 1,
                marginBottom: 10,
              }}
            >
              <View style={{ flexDirection: "row", borderBottomWidth: 1 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "33.3%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ระดับการศึกษา <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "33.3%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  วุฒิการศึกษา <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "33.3%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  สถานศึกษา <Text></Text>
                </Text>
              </View>
              {data.education_histories
                ?.toReversed()
                .map((data: any, index: any) => {
                  return (
                    <>
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "33.3%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                            flexWrap: "wrap",
                          }}
                        >
                          {data.graduation_level ? data.graduation_level : ""}{" "}
                          <Text></Text>
                        </Text>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "33.3%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                            flexWrap: "wrap",
                          }}
                        >
                          {data.graduation_major ? data.graduation_major : ""}{" "}
                          <Text></Text>
                        </Text>
                        <View
                          style={{
                            width: "33.3%",
                            marginLeft: 5,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              fontSize: 10,
                              textAlign: "left",
                            }}
                          >
                            {(() => {
                              const text = data.school_name
                                ? data.school_name
                                : "";

                              // ถ้าข้อความยาวเกิน 25 ตัวอักษร ให้แบ่งเป็น 2 บรรทัด
                              if (text && text.length > 25) {
                                // แบ่งตามคำแทนการแบ่งครึ่ง
                                const words = text.split(" ");
                                const midPoint = Math.ceil(words.length / 2);
                                const firstLine = words
                                  .slice(0, midPoint)
                                  .join(" ");
                                const secondLine = words
                                  .slice(midPoint)
                                  .join(" ");
                                return (
                                  <>
                                    {firstLine}
                                    <Text></Text>
                                    {"\n"}
                                    {secondLine}
                                    <Text></Text>
                                  </>
                                );
                              }
                              return (
                                <>
                                  {text} <Text></Text>
                                </>
                              );
                            })()}
                          </Text>
                        </View>
                      </View>
                    </>
                  );
                })}
            </View>
            <Text
              style={{
                fontFamily: "kanit-regular",
                width: "100%",
                fontSize: 10,
                textAlign: "left",
              }}
            >
              ประวัติเครื่องราชอิสริยาภรณ์
            </Text>
            <View
              style={{
                borderLeftWidth: 1,
                borderTopWidth: 1,
                borderRightWidth: 1,
                borderBottomWidth: 1,
                marginBottom: 10,
              }}
            >
              <View style={{ flexDirection: "row", borderBottomWidth: 1 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "10%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ลำดับ <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "40%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ชื่อ <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ปีที่ได้รับ <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  วันที่ได้รับ <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ประเภท <Text></Text>
                </Text>
              </View>
              {data.insignia_histories?.length > 0 ? (
                data.insignia_histories?.map((data: any, index: any) => {
                  return (
                    <View style={{ flexDirection: "row" }}>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "10%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                          flexWrap: "wrap",
                        }}
                      >
                        {index + 1} <Text></Text>
                      </Text>
                      <View
                        style={{
                          width: "40%",
                          marginLeft: 5,
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            fontSize: 10,
                            textAlign: "left",
                          }}
                        >
                          {(() => {
                            const text = data.name ? data.name : "-";

                            // ถ้าข้อความยาวเกิน 25 ตัวอักษร ให้แบ่งเป็น 2 บรรทัด
                            if (text && text.length > 25) {
                              // แบ่งตามคำแทนการแบ่งครึ่ง
                              const words = text.split(" ");
                              const midPoint = Math.ceil(words.length / 2);
                              const firstLine = words
                                .slice(0, midPoint)
                                .join(" ");
                              const secondLine = words
                                .slice(midPoint)
                                .join(" ");
                              return (
                                <>
                                  {firstLine}
                                  <Text></Text>
                                  {"\n"}
                                  {secondLine}
                                  <Text></Text>
                                </>
                              );
                            }
                            return (
                              <>
                                {text} <Text></Text>
                              </>
                            );
                          })()}
                        </Text>
                      </View>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "25%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                          flexWrap: "wrap",
                        }}
                      >
                        {data.year ? data.year : "-"} <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "25%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                          flexWrap: "wrap",
                        }}
                      >
                        {data.date_of_award
                          ? Moment(data.date_of_award)
                              .add(543, "year")
                              .format("DD/MM/YYYY")
                          : "-"}{" "}
                        <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "25%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                          flexWrap: "wrap",
                        }}
                      >
                        {data.type ? data.type : "-"} <Text></Text>
                      </Text>
                    </View>
                  );
                })
              ) : (
                <View style={{ flexDirection: "row" }}>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "10%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                      flexWrap: "wrap",
                    }}
                  >
                    - <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "40%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                      flexWrap: "wrap",
                    }}
                  >
                    - <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "25%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                      flexWrap: "wrap",
                    }}
                  >
                    - <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "25%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                      flexWrap: "wrap",
                    }}
                  >
                    - <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "25%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                      flexWrap: "wrap",
                    }}
                  >
                    - <Text></Text>
                  </Text>
                </View>
              )}
            </View>

            <Text
              style={{
                fontFamily: "kanit-regular",
                width: "100%",
                fontSize: 10,
                textAlign: "left",
              }}
            >
              ประวัติการลาออก / เกษียณอายุ / เสียชีวิต
            </Text>
            <View
              style={{
                borderLeftWidth: 1,
                borderTopWidth: 1,
                borderRightWidth: 1,
                borderBottomWidth: 1,
                marginBottom: 10,
              }}
            >
              <View style={{ flexDirection: "row", borderBottomWidth: 1 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "35%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  คำสั่ง อตก. ที่ <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  สั่ง ณ วันที่ <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  สถานะ <Text></Text>
                </Text>
              </View>
              {data.resignation_retirement_death_histories?.length > 0 ? (
                data.resignation_retirement_death_histories.map(
                  (item: any, idx: any) => (
                    <View key={idx} style={{ flexDirection: "row" }}>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "35%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                          flexWrap: "wrap",
                        }}
                      >
                        {item.order_no ? item.order_no : "-"} <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "30%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                          flexWrap: "wrap",
                        }}
                      >
                        {item.date
                          ? Moment(item.date)
                              .add(543, "year")
                              .format("DD/MM/YYYY")
                          : "-"}{" "}
                        <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "30%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                          flexWrap: "wrap",
                        }}
                      >
                        {item.status ? item.status : "-"} <Text></Text>
                      </Text>
                    </View>
                  ),
                )
              ) : (
                <View style={{ flexDirection: "row" }}>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "35%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    - <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "30%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    - <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "30%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    - <Text></Text>
                  </Text>
                </View>
              )}
            </View>

            <Text
              style={{
                fontFamily: "kanit-regular",
                width: "100%",
                fontSize: 10,
                textAlign: "left",
              }}
            >
              ประวัติการลงโทษ
            </Text>
            <View
              style={{
                borderLeftWidth: 1,
                borderTopWidth: 1,
                borderRightWidth: 1,
                borderBottomWidth: 1,
                marginBottom: 10,
              }}
            >
              <View style={{ flexDirection: "row", borderBottomWidth: 1 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  เลขที่คำสั่ง <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "45%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  เรื่อง <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  วันที่ <Text></Text>
                </Text>
              </View>
              {data.punishment_histories?.length > 0 ? (
                data.punishment_histories.map((item: any, idx: any) => (
                  <View key={idx} style={{ flexDirection: "row" }}>
                    <Text
                      style={{
                        fontFamily: "kanit-200",
                        width: "25%",
                        fontSize: 10,
                        textAlign: "left",
                        marginLeft: 5,
                        flexWrap: "wrap",
                      }}
                    >
                      {item.order_no ? item.order_no : "-"} <Text></Text>
                    </Text>
                    <View style={{ width: "45%", marginLeft: 5 }}>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          fontSize: 10,
                          textAlign: "left",
                        }}
                      >
                        {item.name ? item.name : "-"} <Text></Text>
                      </Text>
                    </View>
                    <Text
                      style={{
                        fontFamily: "kanit-200",
                        width: "30%",
                        fontSize: 10,
                        textAlign: "left",
                        marginLeft: 5,
                        flexWrap: "wrap",
                      }}
                    >
                      {item.date
                        ? Moment(item.date)
                            .add(543, "year")
                            .format("DD/MM/YYYY")
                        : "-"}{" "}
                      <Text></Text>
                    </Text>
                  </View>
                ))
              ) : (
                <View style={{ flexDirection: "row" }}>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "25%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    - <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "45%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    - <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "30%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    - <Text></Text>
                  </Text>
                </View>
              )}
            </View>

            <View style={{ marginBottom: 10 }}>
              <View style={{ flexDirection: "row" }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "40%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  ประวัติการทำงาน <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "14%",
                    fontSize: 10,
                    textAlign: "left",
                    marginLeft: 5,
                  }}
                >
                  อายุครองตำแหน่ง <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "13%",
                    fontSize: 10,
                    textAlign: "center",
                    marginLeft: 5,
                  }}
                >
                  ระดับตำแหน่ง <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "10%",
                    fontSize: 10,
                    textAlign: "center",
                    marginLeft: 5,
                  }}
                >
                  สังกัด <Text></Text>
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    width: "25%",
                    fontSize: 10,
                    textAlign: "center",
                    marginLeft: 5,
                  }}
                >
                  เริ่ม - สิ้นสุด <Text></Text>
                </Text>
              </View>

              {/* ต้องแก้ไขส่วนที่มีการแสดงข้อมูลด้วย ให้มีความกว้างสอดคล้องกัน */}
              {firstPageRecords.map((historyItem: any, index: any) => (
                <React.Fragment key={historyItem.order_no ?? index}>
                  <View wrap={false} style={{ flexDirection: "row" }}>
                    <View
                      style={{
                        width: "40%",
                        marginLeft: 5,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          fontSize: 10,
                          textAlign: "left",
                        }}
                      >
                        {(() => {
                          const positionName = normalizeText(
                            historyItem.position_name,
                          );
                          const text = positionName
                            ? `${positionName} (${historyItem.order_no})`
                            : "";

                          if (text && text.length > 25) {
                            const words = text.split(" ");
                            if (text.length > 40) {
                              const firstThird = Math.ceil(words.length / 3);
                              const secondThird = Math.ceil(
                                (words.length * 2) / 3,
                              );
                              const firstLine = words
                                .slice(0, firstThird)
                                .join(" ");
                              const secondLine = words
                                .slice(firstThird, secondThird)
                                .join(" ");
                              const thirdLine = words
                                .slice(secondThird)
                                .join(" ");
                              return (
                                firstLine + "\n" + secondLine + "\n" + thirdLine
                              );
                            }
                            const midPoint = Math.ceil(words.length / 2);
                            const firstLine = words
                              .slice(0, midPoint)
                              .join(" ");
                            const secondLine = words.slice(midPoint).join(" ");
                            return firstLine + "\n" + secondLine;
                          }
                          return text;
                        })()}
                        <Text></Text>
                      </Text>
                    </View>
                    <Text
                      style={{
                        fontFamily: "kanit-200",
                        width: "14%",
                        fontSize: 10,
                        textAlign: "left",
                        marginLeft: 5,
                        flexWrap: "wrap",
                      }}
                    >
                      {historyItem.start_date
                        ? getDateDiff(
                            historyItem.start_date,
                            isCurrentPosition(historyItem)
                              ? new Date().toISOString()
                              : historyItem.end_date,
                          )
                        : "-"}
                      <Text></Text>
                    </Text>
                    <Text
                      style={{
                        fontFamily: "kanit-200",
                        width: "13%",
                        fontSize: 10,
                        textAlign: "center",
                        marginLeft: 5,
                        flexWrap: "wrap",
                      }}
                    >
                      {historyItem.position_level
                        ? historyItem.position_level
                        : ""}{" "}
                      <Text></Text>
                    </Text>
                    <View
                      style={{
                        width: "10%",
                        marginLeft: 5,
                        flexShrink: 1,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          fontSize: 10,
                          textAlign: "center",
                        }}
                      >
                        {(() => {
                          const text = historyItem.position_type
                            ? historyItem.position_type
                            : "";
                          if (text && text.length > 10) {
                            const words = text.split(" ");
                            if (words.length === 1) {
                              const midPoint = Math.ceil(text.length / 2);
                              return (
                                text.substring(0, midPoint) +
                                "\n" +
                                text.substring(midPoint)
                              );
                            }
                            if (text.length > 20) {
                              const firstThird = Math.ceil(words.length / 3);
                              const secondThird = Math.ceil(
                                (words.length * 2) / 3,
                              );
                              const firstLine = words
                                .slice(0, firstThird)
                                .join(" ");
                              const secondLine = words
                                .slice(firstThird, secondThird)
                                .join(" ");
                              const thirdLine = words
                                .slice(secondThird)
                                .join(" ");
                              return (
                                firstLine + "\n" + secondLine + "\n" + thirdLine
                              );
                            }
                            const midPoint = Math.ceil(words.length / 2);
                            const firstLine = words
                              .slice(0, midPoint)
                              .join(" ");
                            const secondLine = words.slice(midPoint).join(" ");
                            return firstLine + "\n" + secondLine;
                          }
                          return text;
                        })()}
                        <Text></Text>
                      </Text>
                    </View>
                    <View
                      style={{
                        width: "25%",
                        marginLeft: 5,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          fontSize: 10,
                          textAlign: "center",
                        }}
                      >
                        {(() => {
                          const startDate = historyItem.start_date
                            ? Moment(historyItem.start_date)
                                .add(543, "year")
                                .format("DD/MM/YYYY")
                            : "";
                          const endDate = isCurrentPosition(historyItem)
                            ? "ปัจจุบัน"
                            : historyItem.end_date
                              ? Moment(historyItem.end_date)
                                  .add(543, "year")
                                  .format("DD/MM/YYYY")
                              : "";
                          const text = `${startDate} - ${endDate}`;
                          if (text && text.length > 25) {
                            const words = text.split(" ");
                            const midPoint = Math.ceil(words.length / 2);
                            const firstLine = words
                              .slice(0, midPoint)
                              .join(" ");
                            const secondLine = words.slice(midPoint).join(" ");
                            return firstLine + "\n" + secondLine;
                          }
                          return text;
                        })()}
                        <Text></Text>
                      </Text>
                    </View>
                  </View>
                </React.Fragment>
              ))}
            </View>
          </View>

          <View
            fixed
            style={{
              position: "absolute",
              bottom: 0,
              left: 10,
              right: 10,
              flexDirection: "row",
              borderTopWidth: 0.5,
              paddingTop: 3,
            }}
          >
            <Text
              style={{
                fontFamily: "kanit-200",
                fontSize: 8,
                width: "50%",
                textAlign: "left",
              }}
            >
              {getThaiDateTime()} <Text></Text>
            </Text>
            <Text
              style={{
                fontFamily: "kanit-200",
                fontSize: 8,
                width: "50%",
                textAlign: "right",
              }}
              render={({ pageNumber, totalPages }) =>
                `หน้า ${pageNumber}/${totalPages}`
              }
            />
          </View>
        </Page>

        {/* Page 3+: ประวัติการทำงานที่ล้น - แสดงรูปและข้อมูลส่วนตัวซ้ำ + record ที่เกิน */}
        {overflowRecords.length > 0 &&
          overflowChunks.map((chunk, chunkIndex) => (
              <Page
                key={`overflow-${chunkIndex}`}
                size="A4"
                style={{ padding: 10 }}
              >
                <View>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 15,
                      textAlign: "center",
                      marginBottom: 10,
                    }}
                  >
                    ข้อมูลประวัติการทำงาน <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      fontSize: 10,
                      textAlign: "center",
                      marginBottom: 10,
                    }}
                  >
                    {data.prefix_name_th ? data.prefix_name_th : ""}{" "}
                    {data.firstname_th ? data.firstname_th : ""}{" "}
                    {data.lastname_th ? data.lastname_th : ""}
                  </Text>

                  <View style={{ marginBottom: 10 }}>
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                      }}
                    >
                      <View style={{ flex: 1 }}>
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Image
                            src={
                              data.photo
                                ? getMediaPath(data.photo)
                                : "/static/no-image.png"
                            }
                            style={{
                              width: 85,
                              height: 95,
                              objectFit: "cover",
                              borderRadius: 5,
                            }}
                          />
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 5,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: "kanit-regular",
                              fontSize: 10,
                            }}
                          >
                            เกษียณอายุในปี{" "}
                            <Text style={{ fontFamily: "kanit-200" }}>
                              {data.birthday
                                ? (() => {
                                    const birthMoment = Moment(data.birthday);
                                    const retirementYear =
                                      parseInt(
                                        Moment(data.birthday)
                                          .add(543, "year")
                                          .format("YYYY"),
                                      ) + 60;
                                    const month = birthMoment.month();
                                    const day = birthMoment.date();
                                    // เกิดตั้งแต่ 2 ต.ค. เป็นต้นไป (รวม พ.ย./ธ.ค.) → +1 ปี
                                    // เพราะปีงบประมาณไทยสิ้นสุด 30 ก.ย. คนที่อายุครบ 60
                                    // หลังวันที่ 1 ต.ค. จะอยู่ในปีงบประมาณถัดไป
                                    const addOne =
                                      month > 9 || (month === 9 && day >= 2);
                                    return retirementYear + (addOne ? 1 : 0);
                                  })()
                                : ""}{" "}
                              <Text></Text>
                            </Text>
                          </Text>
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            marginTop: 5,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: "kanit-regular",
                              fontSize: 10,
                            }}
                          >
                            ตำแหน่งปัจจุบัน{" "}
                            <Text style={{ fontFamily: "kanit-200" }}>
                              {data.current_job_position?.position_name || ""}{" "}
                              <Text></Text>
                            </Text>
                          </Text>
                        </View>
                        <Text
                          style={{
                            fontFamily: "kanit-regular",
                            fontSize: 10,
                            marginTop: 5,
                          }}
                        >
                          อัตราเงินเดือนปัจจุบัน{" "}
                          <Text style={{ fontFamily: "kanit-200" }}>
                            {data.salary ? addCommas(data.salary) : "-"}{" "}
                            <Text></Text>
                          </Text>{" "}
                          บาท
                        </Text>
                      </View>
                    </View>
                    <View style={{ flexDirection: "row" }}>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "33.3%",
                          fontSize: 10,
                          textAlign: "left",
                        }}
                      >
                        วันเดือนปีเกิด{" "}
                        <Text style={{ fontFamily: "kanit-200" }}>
                          {data.birthday
                            ? Moment(data.birthday)
                                .add(543, "year")
                                .format("DD/MM/YYYY")
                            : ""}{" "}
                          <Text></Text>
                        </Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "33.3%",
                          fontSize: 10,
                          textAlign: "left",
                        }}
                      >
                        อายุ{" "}
                        <Text style={{ fontFamily: "kanit-200" }}>
                          {data.birthday ? getAge(data.birthday) : ""}{" "}
                          <Text></Text>
                        </Text>
                      </Text>
                    </View>
                    <View style={{ flexDirection: "row", marginBottom: 3 }}>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "50%",
                          fontSize: 10,
                          textAlign: "left",
                        }}
                      >
                        บรรจุเข้าทำงานเมื่อวันที่{" "}
                        <Text style={{ fontFamily: "kanit-200" }}>
                          {workHistories[0]?.start_date
                            ? Moment(workHistories[0].start_date)
                                .add(543, "year")
                                .format("DD/MM/YYYY")
                            : ""}{" "}
                          <Text></Text>
                        </Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "50%",
                          fontSize: 10,
                          textAlign: "left",
                        }}
                      >
                        อายุงาน{" "}
                        <Text style={{ fontFamily: "kanit-200" }}>
                          {workHistories[0]?.start_date
                            ? getDateDiff(
                                workHistories[0].start_date,
                                new Date().toISOString(),
                              )
                            : ""}{" "}
                          <Text></Text>
                        </Text>
                      </Text>
                    </View>
                    <View style={{ flexDirection: "row", marginBottom: 3 }}>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "50%",
                          fontSize: 10,
                          textAlign: "left",
                        }}
                      >
                        {data.current_job_position?.employee_type ===
                          "ลูกจ้างประจำ" &&
                          (() => {
                            const reversedHistories = data.mof_work_histories
                              ?.filter((item: any) => item.order_no != null)
                              .toReversed();
                            const latestLevel =
                              reversedHistories?.[0]?.position_level;
                            let targetHistory = reversedHistories?.[0];
                            if (latestLevel && reversedHistories) {
                              for (
                                let i = reversedHistories.length - 1;
                                i >= 0;
                                i--
                              ) {
                                if (
                                  reversedHistories[i]?.position_level ===
                                  latestLevel
                                ) {
                                  targetHistory = reversedHistories[i];
                                  break;
                                }
                              }
                            }
                            return targetHistory ? (
                              <>
                                ครองระดับในตำแหน่งปัจจุบันเมื่อวันที่{" "}
                                <Text style={{ fontFamily: "kanit-200" }}>
                                  {targetHistory.start_date
                                    ? Moment(targetHistory.start_date)
                                        .add(543, "year")
                                        .format("DD/MM/YYYY")
                                    : ""}{" "}
                                  <Text></Text>
                                </Text>
                              </>
                            ) : null;
                          })()}
                        {data.current_job_position?.employee_type ===
                          "พนักงาน" &&
                          (() => {
                            const histories = data.mof_work_histories?.filter(
                              (item: any) => item.order_no != null,
                            );
                            const latestLevel = histories?.[0]?.position_level;
                            let targetHistory = histories?.[0];
                            if (latestLevel && histories) {
                              for (let i = histories.length - 1; i >= 0; i--) {
                                if (
                                  histories[i]?.position_level === latestLevel
                                ) {
                                  targetHistory = histories[i];
                                  break;
                                }
                              }
                            }
                            return targetHistory ? (
                              <>
                                ครองระดับในตำแหน่งปัจจุบันเมื่อวันที่{" "}
                                <Text style={{ fontFamily: "kanit-200" }}>
                                  {targetHistory.start_date
                                    ? Moment(targetHistory.start_date)
                                        .add(543, "year")
                                        .format("DD/MM/YYYY")
                                    : ""}{" "}
                                  <Text></Text>
                                </Text>
                              </>
                            ) : null;
                          })()}
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "50%",
                          fontSize: 10,
                          textAlign: "left",
                        }}
                      >
                        {data.current_job_position?.employee_type ===
                          "ลูกจ้างประจำ" &&
                          (() => {
                            const reversedHistories = data.mof_work_histories
                              ?.filter((item: any) => item.order_no != null)
                              .toReversed();
                            const latestLevel =
                              reversedHistories?.[0]?.position_level;
                            let targetHistory = reversedHistories?.[0];
                            if (latestLevel && reversedHistories) {
                              for (
                                let i = reversedHistories.length - 1;
                                i >= 0;
                                i--
                              ) {
                                if (
                                  reversedHistories[i]?.position_level ===
                                  latestLevel
                                ) {
                                  targetHistory = reversedHistories[i];
                                  break;
                                }
                              }
                            }
                            return targetHistory ? (
                              <>
                                อายุงาน{" "}
                                <Text style={{ fontFamily: "kanit-200" }}>
                                  {targetHistory.start_date
                                    ? getDateDiff(
                                        targetHistory.start_date,
                                        new Date().toISOString(),
                                      )
                                    : ""}{" "}
                                  <Text></Text>
                                </Text>
                              </>
                            ) : null;
                          })()}
                        {data.current_job_position?.employee_type ===
                          "พนักงาน" &&
                          (() => {
                            const histories = data.mof_work_histories?.filter(
                              (item: any) => item.order_no != null,
                            );
                            const latestLevel = histories?.[0]?.position_level;
                            let targetHistory = histories?.[0];
                            if (latestLevel && histories) {
                              for (let i = histories.length - 1; i >= 0; i--) {
                                if (
                                  histories[i]?.position_level === latestLevel
                                ) {
                                  targetHistory = histories[i];
                                  break;
                                }
                              }
                            }
                            return targetHistory ? (
                              <>
                                อายุงาน{" "}
                                <Text style={{ fontFamily: "kanit-200" }}>
                                  {targetHistory.start_date
                                    ? getDateDiff(
                                        targetHistory.start_date,
                                        new Date().toISOString(),
                                      )
                                    : ""}{" "}
                                  <Text></Text>
                                </Text>
                              </>
                            ) : null;
                          })()}
                      </Text>
                    </View>
                  </View>

                  <View
                    style={{
                      borderLeftWidth: 1,
                      borderTopWidth: 1,
                      borderRightWidth: 1,
                      borderBottomWidth: 1,
                      marginBottom: 10,
                    }}
                  >
                    <View
                      style={{ flexDirection: "row", borderBottomWidth: 1 }}
                    >
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "33.3%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        ระดับการศึกษา <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "33.3%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        วุฒิการศึกษา <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "33.3%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        สถานศึกษา <Text></Text>
                      </Text>
                    </View>
                    {data.education_histories
                      ?.toReversed()
                      .map((edu: any, idx: any) => (
                        <View key={idx} style={{ flexDirection: "row" }}>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "33.3%",
                              fontSize: 10,
                              textAlign: "left",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {edu.graduation_level ? edu.graduation_level : ""}{" "}
                            <Text></Text>
                          </Text>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "33.3%",
                              fontSize: 10,
                              textAlign: "left",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {edu.graduation_major ? edu.graduation_major : ""}{" "}
                            <Text></Text>
                          </Text>
                          <View style={{ width: "33.3%", marginLeft: 5 }}>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                fontSize: 10,
                                textAlign: "left",
                              }}
                            >
                              {(() => {
                                const text = edu.school_name
                                  ? edu.school_name
                                  : "";
                                if (text && text.length > 25) {
                                  const words = text.split(" ");
                                  const midPoint = Math.ceil(words.length / 2);
                                  const firstLine = words
                                    .slice(0, midPoint)
                                    .join(" ");
                                  const secondLine = words
                                    .slice(midPoint)
                                    .join(" ");
                                  return firstLine + "\n" + secondLine;
                                }
                                return text;
                              })()}{" "}
                              <Text></Text>
                            </Text>
                          </View>
                        </View>
                      ))}
                  </View>
                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "100%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ประวัติเครื่องราชอิสริยาภรณ์
                  </Text>
                  <View
                    style={{
                      borderLeftWidth: 1,
                      borderTopWidth: 1,
                      borderRightWidth: 1,
                      borderBottomWidth: 1,
                      marginBottom: 10,
                    }}
                  >
                    <View
                      style={{ flexDirection: "row", borderBottomWidth: 1 }}
                    >
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "10%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        ลำดับ <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "40%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        ชื่อ <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "25%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        ปีที่ได้รับ <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "25%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        วันที่ได้รับ <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "25%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        ประเภท <Text></Text>
                      </Text>
                    </View>
                    {data.insignia_histories?.length > 0 ? (
                      data.insignia_histories?.map((insig: any, idx: any) => (
                        <View key={idx} style={{ flexDirection: "row" }}>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "10%",
                              fontSize: 10,
                              textAlign: "left",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {idx + 1} <Text></Text>
                          </Text>
                          <View style={{ width: "40%", marginLeft: 5 }}>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                fontSize: 10,
                                textAlign: "left",
                              }}
                            >
                              {insig.name ? insig.name : "-"} <Text></Text>
                            </Text>
                          </View>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "25%",
                              fontSize: 10,
                              textAlign: "left",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {insig.year ? insig.year : "-"} <Text></Text>
                          </Text>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "25%",
                              fontSize: 10,
                              textAlign: "left",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {insig.date_of_award
                              ? Moment(insig.date_of_award)
                                  .add(543, "year")
                                  .format("DD/MM/YYYY")
                              : "-"}{" "}
                            <Text></Text>
                          </Text>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "25%",
                              fontSize: 10,
                              textAlign: "left",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {insig.type ? insig.type : "-"} <Text></Text>
                          </Text>
                        </View>
                      ))
                    ) : (
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "10%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                            flexWrap: "wrap",
                          }}
                        >
                          - <Text></Text>
                        </Text>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "40%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                            flexWrap: "wrap",
                          }}
                        >
                          - <Text></Text>
                        </Text>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "25%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                            flexWrap: "wrap",
                          }}
                        >
                          - <Text></Text>
                        </Text>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "25%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                            flexWrap: "wrap",
                          }}
                        >
                          - <Text></Text>
                        </Text>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "25%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                            flexWrap: "wrap",
                          }}
                        >
                          - <Text></Text>
                        </Text>
                      </View>
                    )}
                  </View>

                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "100%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ประวัติการลาออก / เกษียณอายุ / เสียชีวิต
                  </Text>
                  <View
                    style={{
                      borderLeftWidth: 1,
                      borderTopWidth: 1,
                      borderRightWidth: 1,
                      borderBottomWidth: 1,
                      marginBottom: 10,
                    }}
                  >
                    <View
                      style={{ flexDirection: "row", borderBottomWidth: 1 }}
                    >
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "35%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        คำสั่ง อตก. ที่ <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "30%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        สั่ง ณ วันที่ <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "30%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        สถานะ <Text></Text>
                      </Text>
                    </View>
                    {data.resignation_retirement_death_histories?.length > 0 ? (
                      data.resignation_retirement_death_histories.map(
                        (item: any, idx: any) => (
                          <View key={idx} style={{ flexDirection: "row" }}>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "35%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                                flexWrap: "wrap",
                              }}
                            >
                              {item.order_no ? item.order_no : "-"}{" "}
                              <Text></Text>
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "30%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                                flexWrap: "wrap",
                              }}
                            >
                              {item.date
                                ? Moment(item.date)
                                    .add(543, "year")
                                    .format("DD/MM/YYYY")
                                : "-"}{" "}
                              <Text></Text>
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "30%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                                flexWrap: "wrap",
                              }}
                            >
                              {item.status ? item.status : "-"} <Text></Text>
                            </Text>
                          </View>
                        ),
                      )
                    ) : (
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "35%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                          }}
                        >
                          - <Text></Text>
                        </Text>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "30%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                          }}
                        >
                          - <Text></Text>
                        </Text>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "30%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                          }}
                        >
                          - <Text></Text>
                        </Text>
                      </View>
                    )}
                  </View>

                  <Text
                    style={{
                      fontFamily: "kanit-regular",
                      width: "100%",
                      fontSize: 10,
                      textAlign: "left",
                    }}
                  >
                    ประวัติการลงโทษ
                  </Text>
                  <View
                    style={{
                      borderLeftWidth: 1,
                      borderTopWidth: 1,
                      borderRightWidth: 1,
                      borderBottomWidth: 1,
                      marginBottom: 10,
                    }}
                  >
                    <View
                      style={{ flexDirection: "row", borderBottomWidth: 1 }}
                    >
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "25%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        เลขที่คำสั่ง <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "45%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        เรื่อง <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "30%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        วันที่ <Text></Text>
                      </Text>
                    </View>
                    {data.punishment_histories?.length > 0 ? (
                      data.punishment_histories.map((item: any, idx: any) => (
                        <View key={idx} style={{ flexDirection: "row" }}>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "25%",
                              fontSize: 10,
                              textAlign: "left",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {item.order_no ? item.order_no : "-"} <Text></Text>
                          </Text>
                          <View style={{ width: "45%", marginLeft: 5 }}>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                fontSize: 10,
                                textAlign: "left",
                              }}
                            >
                              {item.name ? item.name : "-"} <Text></Text>
                            </Text>
                          </View>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "30%",
                              fontSize: 10,
                              textAlign: "left",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {item.date
                              ? Moment(item.date)
                                  .add(543, "year")
                                  .format("DD/MM/YYYY")
                              : "-"}{" "}
                            <Text></Text>
                          </Text>
                        </View>
                      ))
                    ) : (
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "25%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                          }}
                        >
                          - <Text></Text>
                        </Text>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "45%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                          }}
                        >
                          - <Text></Text>
                        </Text>
                        <Text
                          style={{
                            fontFamily: "kanit-200",
                            width: "30%",
                            fontSize: 10,
                            textAlign: "left",
                            marginLeft: 5,
                          }}
                        >
                          - <Text></Text>
                        </Text>
                      </View>
                    )}
                  </View>

                  <View style={{ marginBottom: 10 }}>
                    <View style={{ flexDirection: "row" }}>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "40%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        ประวัติการทำงาน <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "14%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        อายุครองตำแหน่ง <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "13%",
                          fontSize: 10,
                          textAlign: "center",
                          marginLeft: 5,
                        }}
                      >
                        ระดับตำแหน่ง <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "10%",
                          fontSize: 10,
                          textAlign: "center",
                          marginLeft: 5,
                        }}
                      >
                        สังกัด <Text></Text>
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-regular",
                          width: "25%",
                          fontSize: 10,
                          textAlign: "center",
                          marginLeft: 5,
                        }}
                      >
                        เริ่ม - สิ้นสุด <Text></Text>
                      </Text>
                    </View>

                    {chunk.map((historyItem: any, index: any) => (
                      <React.Fragment key={historyItem.order_no ?? index}>
                        <View wrap={false} style={{ flexDirection: "row" }}>
                          <View
                            style={{
                              width: "40%",
                              marginLeft: 5,
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                fontSize: 10,
                                textAlign: "left",
                              }}
                            >
                              {(() => {
                                const positionName = normalizeText(
                                  historyItem.position_name,
                                );
                                const text = positionName
                                  ? `${positionName} (${historyItem.order_no})`
                                  : "";
                                if (text && text.length > 25) {
                                  const words = text.split(" ");
                                  if (text.length > 40) {
                                    const firstThird = Math.ceil(
                                      words.length / 3,
                                    );
                                    const secondThird = Math.ceil(
                                      (words.length * 2) / 3,
                                    );
                                    const firstLine = words
                                      .slice(0, firstThird)
                                      .join(" ");
                                    const secondLine = words
                                      .slice(firstThird, secondThird)
                                      .join(" ");
                                    const thirdLine = words
                                      .slice(secondThird)
                                      .join(" ");
                                    return (
                                      firstLine +
                                      "\n" +
                                      secondLine +
                                      "\n" +
                                      thirdLine
                                    );
                                  }
                                  const midPoint = Math.ceil(words.length / 2);
                                  const firstLine = words
                                    .slice(0, midPoint)
                                    .join(" ");
                                  const secondLine = words
                                    .slice(midPoint)
                                    .join(" ");
                                  return firstLine + "\n" + secondLine;
                                }
                                return text;
                              })()}
                              <Text></Text>
                            </Text>
                          </View>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "14%",
                              fontSize: 10,
                              textAlign: "left",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {historyItem.start_date
                              ? getDateDiff(
                                  historyItem.start_date,
                                  isCurrentPosition(historyItem)
                                    ? new Date().toISOString()
                                    : historyItem.end_date,
                                )
                              : "-"}
                            <Text></Text>
                          </Text>
                          <Text
                            style={{
                              fontFamily: "kanit-200",
                              width: "13%",
                              fontSize: 10,
                              textAlign: "center",
                              marginLeft: 5,
                              flexWrap: "wrap",
                            }}
                          >
                            {historyItem.position_level
                              ? historyItem.position_level
                              : ""}{" "}
                            <Text></Text>
                          </Text>
                          <View
                            style={{
                              width: "10%",
                              marginLeft: 5,
                              flexShrink: 1,
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                fontSize: 10,
                                textAlign: "center",
                              }}
                            >
                              {(() => {
                                const text = historyItem.position_type
                                  ? historyItem.position_type
                                  : "";
                                if (text && text.length > 10) {
                                  const words = text.split(" ");
                                  if (words.length === 1) {
                                    const midPoint = Math.ceil(text.length / 2);
                                    return (
                                      text.substring(0, midPoint) +
                                      "\n" +
                                      text.substring(midPoint)
                                    );
                                  }
                                  if (text.length > 20) {
                                    const firstThird = Math.ceil(
                                      words.length / 3,
                                    );
                                    const secondThird = Math.ceil(
                                      (words.length * 2) / 3,
                                    );
                                    const firstLine = words
                                      .slice(0, firstThird)
                                      .join(" ");
                                    const secondLine = words
                                      .slice(firstThird, secondThird)
                                      .join(" ");
                                    const thirdLine = words
                                      .slice(secondThird)
                                      .join(" ");
                                    return (
                                      firstLine +
                                      "\n" +
                                      secondLine +
                                      "\n" +
                                      thirdLine
                                    );
                                  }
                                  const midPoint = Math.ceil(words.length / 2);
                                  const firstLine = words
                                    .slice(0, midPoint)
                                    .join(" ");
                                  const secondLine = words
                                    .slice(midPoint)
                                    .join(" ");
                                  return firstLine + "\n" + secondLine;
                                }
                                return text;
                              })()}
                              <Text></Text>
                            </Text>
                          </View>
                          <View
                            style={{
                              width: "25%",
                              marginLeft: 5,
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                fontSize: 10,
                                textAlign: "center",
                              }}
                            >
                              {(() => {
                                const startDate = historyItem.start_date
                                  ? Moment(historyItem.start_date)
                                      .add(543, "year")
                                      .format("DD/MM/YYYY")
                                  : "";
                                const endDate = isCurrentPosition(historyItem)
                                  ? "ปัจจุบัน"
                                  : historyItem.end_date
                                    ? Moment(historyItem.end_date)
                                        .add(543, "year")
                                        .format("DD/MM/YYYY")
                                    : "";
                                const text = `${startDate} - ${endDate}`;
                                if (text && text.length > 25) {
                                  const words = text.split(" ");
                                  const midPoint = Math.ceil(words.length / 2);
                                  const firstLine = words
                                    .slice(0, midPoint)
                                    .join(" ");
                                  const secondLine = words
                                    .slice(midPoint)
                                    .join(" ");
                                  return firstLine + "\n" + secondLine;
                                }
                                return text;
                              })()}
                              <Text></Text>
                            </Text>
                          </View>
                        </View>
                      </React.Fragment>
                    ))}
                  </View>
                </View>

                <View
                  fixed
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 10,
                    right: 10,
                    flexDirection: "row",
                    borderTopWidth: 0.5,
                    paddingTop: 3,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      fontSize: 8,
                      width: "50%",
                      textAlign: "left",
                    }}
                  >
                    {getThaiDateTime()} <Text></Text>
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      fontSize: 8,
                      width: "50%",
                      textAlign: "right",
                    }}
                    render={({ pageNumber, totalPages }) =>
                      `หน้า ${pageNumber}/${totalPages}`
                    }
                  />
                </View>
              </Page>
            ))}
      </Document>
    );
  };

  return (
    <>
      {/* <PDFViewer style={{ width: '100%', height: '100vh' }}>
        <PDF />
      </PDFViewer> */}
      {loaderComponent}
      <div className="d-flex flex-column flex-sm-row">
        <div className="employee-image-card d-flex justify-content-center">
          {displayPhoto()}
        </div>
        <div className="w-100 d-flex justify-content-between flex-column flex-sm-row">
          <div className="">
            <p className="m-0 mb-1 mx-2">
              <b>
                {data.prefix_name_th ? data.prefix_name_th : ""}
                {data.firstname_th ? data.firstname_th : "-"}{" "}
                {data.lastname_th ? data.lastname_th : "-"}
              </b>
            </p>
            <p className="m-0 my-1 mx-2">
              <b>รหัสพนักงาน</b> : {data.code ? data.code : "-"}
            </p>
            <p className="m-0 my-1 mx-2">
              <b>ตำแหน่ง</b> :{" "}
              {data.current_job_position?.position_name
                ? data.current_job_position?.position_name
                : "-"}
            </p>
            <p className="m-0 my-1 mx-2">
              <b>แผนก</b> :{" "}
              {data.current_job_position?.structure_departments_name
                ? data.current_job_position?.structure_departments_name
                : "-"}
            </p>
            <p className="m-0 my-1 mx-2">
              <b>กอง / กลุ่ม</b> :{" "}
              {data.current_job_position?.division_group_office_name
                ? data.current_job_position?.division_group_office_name
                : "-"}
            </p>
          </div>
          <div>
            <a href="/report/registration-personnel-history/report-personnel-history">
              <Button
                variant=""
                className="btn-action me-2 btn-outline-secondary"
                onClick={() => {}}
              >
                <FontAwesomeIcon icon={faCaretLeft} className="me-2" />
                ย้อนกลับ
              </Button>
            </a>
            <Link to="#">
              <Button
                variant="primary"
                className="btn-action btn-mof-primary me-2"
                onClick={exportToExcel}
                disabled={isDisableExport}
              >
                <FontAwesomeIcon icon={faFileExport} className="me-2" />
                Export Excel
              </Button>
            </Link>
            <PDFDownloadLink
              document={<PDF />}
              fileName="รายงานประวัติบุคลากร.pdf"
            >
              {
                (({ blob, url, loading, error }: any) => (
                  <Button
                    variant="primary"
                    className="btn-action btn-mof-primary"
                    onClick={() => {}}
                  >
                    <FontAwesomeIcon icon={faFileExport} className="me-2" />
                    Export PDF
                  </Button>
                )) as any
              }
            </PDFDownloadLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonnelHeader;
